export function sellersPropertyDisclosureResidential2026() {
return [   // Release 2025-12-20 19:01:11
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date SPD completed by Seller", 
   fontSize: 9,
   type: "date",
   top: 527.52,
   left: 178.0,
   width: 165.0,
   height: 11.269
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 545.52,
   left: 90.16,
   width: 475.08,
   height: 11.269
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 563.52,
   left: 79.12,
   width: 489.96,
   height: 11.269
}
,
{
   page: 0,
   name: "Listing Year Built", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 581.52,
   left: 97.72,
   width: 469.92,
   height: 11.269
}
,
{
   page: 0,
   name: "Year Seller Acquired Property", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 599.52,
   left: 177.64,
   width: 390.00,
   height: 11.269
}
,
{
   page: 0,
   name: "Radiobutton SellerOccupyingProperty Is", 
   isText: false,
   type: "checkbox",
   top: 617.097,
   left: 77.9009,
   width: 13.6800,
   height: 13.680
}
,
{
   page: 0,
   name: "Radiobutton SellerOccupyingProperty Is Not", 
   isText: false,
   type: "checkbox",
   top: 616.588,
   left: 113.033,
   width: 13.680,
   height: 13.680
}
,
{
   page: 0,
   name: "Date Last Occupied", 
   fontSize: 9,
   type: "date",
   top: 635.52,
   left: 397.96,
   width: 168.12,
   height: 11.269
}
,
{
   page: 0,
   name: "Checkbox Vacant", 
   isText: false,
   type: "checkbox",
   top: 652.661,
   left: 375.581,
   width: 13.680,
   height: 13.680
}
,
{
   page: 0,
   name: "Checkbox Occupied", 
   isText: false,
   type: "checkbox",
   top: 666.275,
   left: 375.78,
   width: 13.68,
   height: 13.680
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Structural problems with improvements", 
   isText: false,
   type: "checkbox",
   top: 125.727,
   left: 148.349,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "BuildingConditions Structural problems with improvements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 121.08,
   left: 168,
   width: 425.16,
   height: 70.44
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Structural supports or reinforcements added", 
   isText: false,
   type: "checkbox",
   top: 198.601,
   left: 148.349,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "BuildingConditions Structural supports or reinforcements added", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 193.32,
   left: 168,
   width: 425.16,
   height: 59.16
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Moisture andor water including but not limited to leakageseepage in the basementcrawlspace", 
   isText: false,
   type: "checkbox",
   top: 257.861,
   left: 148.349,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "BuildingConditions Moisture andor water including but not limited to leakageseepage in the basementcrawlspace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 254.28,
   left: 168,
   width: 425.16,
   height: 70.68
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Damage due to termites other insects birds animals or rodents", 
   isText: false,
   type: "checkbox",
   top: 330.735,
   left: 148.349,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "BuildingConditions Damage due to termites other insects birds animals or rodents", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 326.76,
   left: 168,
   width: 425.16,
   height: 58.92
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Damage due to hail wind fire flood or other casualty", 
   isText: false,
   type: "checkbox",
   top: 393.198,
   left: 148.349,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "BuildingConditions Damage due to hail wind fire flood or other casualty", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 387.48,
   left: 168,
   width: 425.16,
   height: 70.68
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Settling movement cracking heaving breakage of Foundations", 
   isText: false,
   type: "checkbox",
   top: 481.288,
   left: 148.349,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "BuildingConditions Settling movement cracking heaving breakage of Foundations", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 475.8,
   left: 168.0,
   width: 425.16,
   height: 57.24
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Settling movement cracking heaving breakage of Floors", 
   isText: false,
   type: "checkbox",
   top: 537.344,
   left: 148.349,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "BuildingConditions Settling movement cracking heaving breakage of Floors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 534.36,
   left: 168.0,
   width: 425.16,
   height: 43.56
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Settling movement cracking heaving breakage of Interior Walls", 
   isText: false,
   type: "checkbox",
   top: 584.592,
   left: 148.349,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "BuildingConditions Settling movement cracking heaving breakage of Interior Walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 579.24,
   left: 168.0,
   width: 425.16,
   height: 43.56
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Settling movement cracking heaving breakage of Exterior Walls", 
   isText: false,
   type: "checkbox",
   top: 627.035,
   left: 148.349,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "BuildingConditions Settling movement cracking heaving breakage of Exterior Walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 624.12,
   left: 168.0,
   width: 425.16,
   height: 43.32
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Settling movement cracking heaving breakage of Driveways", 
   isText: false,
   type: "checkbox",
   top: 670.279,
   left: 148.349,
   width: 13.680,
   height: 13.680
}
,
{
   page: 1,
   name: "BuildingConditions Settling movement cracking heaving breakage of Driveways", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 668.76,
   left: 168.0,
   width: 425.16,
   height: 43.56
}
,
{
   page: 1,
   name: "Checkbox BuildingConditions Settling movement cracking heaving breakage of Sidewalks", 
   isText: false,
   type: "checkbox",
   top: 715.1245,
   left: 148.349,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 1,
   name: "BuildingConditions Settling movement cracking heaving breakage of Sidewalks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 713.64,
   left: 168.0,
   width: 425.16,
   height: 43.56
}
,
{
   page: 2,
   name: "Checkbox BuildingConditions Settling movement cracking heaving breakage of Patios", 
   isText: false,
   type: "checkbox",
   top: 72.073,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "BuildingConditions Settling movement cracking heaving breakage of Patios", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 66.36,
   left: 168,
   width: 425.16,
   height: 47.64
}
,
{
   page: 2,
   name: "Checkbox BuildingConditions Settling movement cracking heaving breakage of Retaining Walls", 
   isText: false,
   type: "checkbox",
   top: 120.922,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "BuildingConditions Settling movement cracking heaving breakage of Retaining Walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 115.8,
   left: 168,
   width: 425.16,
   height: 47.64
}
,
{
   page: 2,
   name: "Checkbox BuildingConditions Settling movement cracking heaving breakage of Other", 
   isText: false,
   type: "checkbox",
   top: 168.17,
   left: 148.951,
   width: 13.680,
   height: 13.68
}
,
{
   page: 2,
   name: "BuildingConditions Settling movement cracking heaving breakage of Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 164.88,
   left: 167.76,
   width: 425.64,
   height: 29.16
}
,
{
   page: 2,
   name: "Checkbox BuildingConditions Window Leaks", 
   isText: false,
   type: "checkbox",
   top: 200.203,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "BuildingConditions Window leaks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 196.2,
   left: 168,
   width: 425.16,
   height: 56.76
}
,
{
   page: 2,
   name: "Checkbox BuildingConditions Exterior Artificial Stucco EIFS", 
   isText: false,
   type: "checkbox",
   top: 260.264,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "BuildingConditions Exterior Artificial Stucco EIFS", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 254.4,
   left: 167.76,
   width: 425.64,
   height: 29.16
}
,
{
   page: 2,
   name: "Checkbox BuildingConditions Subfloors", 
   isText: false,
   type: "checkbox",
   top: 289.093,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "BuildingConditions Subfloors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 285.72,
   left: 168,
   width: 425.16,
   height: 43.08
}
,
{
   page: 2,
   name: "BuildingConditions Extra Event", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 330.24,
   left: 33.12,
   width: 110.28,
   height: 29.16
}
,
{
   page: 2,
   name: "Checkbox BuildingConditions Extra", 
   isText: false,
   type: "checkbox",
   top: 333.137,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "BuildingConditions Extra", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 330.24,
   left: 167.76,
   width: 425.64,
   height: 29.16
}
,
{
   page: 2,
   name: "Checkbox RoofGeneral Indicate age of roof in Comments", 
   isText: false,
   type: "checkbox",
   top: 454.861,
   left: 138.74,
   width: 13.68,
   height: 13.680
}
,
{
   page: 2,
   name: "RoofGeneral Indicate age of roof in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 453.12,
   left: 158.64,
   width: 434.76,
   height: 30.00
}
,
{
   page: 2,
   name: "Checkbox RoofGeneral Indicate roof material in Comments", 
   isText: false,
   type: "checkbox",
   top: 489.296,
   left: 138.74,
   width: 13.68,
   height: 13.680
}
,
{
   page: 2,
   name: "RoofGeneral Indicate roof material in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 487.08,
   left: 158.64,
   width: 434.76,
   height: 29.88
}
,
{
   page: 2,
   name: "Checkbox RoofGeneral Roof is under warranty", 
   isText: false,
   type: "checkbox",
   top: 522.93,
   left: 138.74,
   width: 13.68,
   height: 13.68
}
,
{
   page: 2,
   name: "RoofGeneral Roof is under warranty", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 520.92,
   left: 158.64,
   width: 434.76,
   height: 29.88
}
,
{
   page: 2,
   name: "Checkbox RoofGeneral Date of warranty expiration", 
   isText: false,
   type: "checkbox",
   top: 557.365,
   left: 138.74,
   width: 13.68,
   height: 13.680
}
,
{
   page: 2,
   name: "RoofGeneral Date of warranty expiration", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 554.76,
   left: 158.64,
   width: 434.76,
   height: 29.88
}
,
{
   page: 2,
   name: "Checkbox RoofGeneral Warranty is transferable", 
   isText: false,
   type: "checkbox",
   top: 590.999,
   left: 138.74,
   width: 13.68,
   height: 13.680
}
,
{
   page: 2,
   name: "Radiobutton RoofWarrantyTransferable Yes", 
   isText: false,
   type: "checkbox",
   top: 589.397,
   left: 163.366,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Radiobutton RoofWarrantyTransferable No", 
   isText: false,
   type: "checkbox",
   top: 588.596,
   left: 201.004,
   width: 13.680,
   height: 13.680
}
,
{
   page: 2,
   name: "Radiobutton RoofWarrantyTransferable Unknown", 
   isText: false,
   type: "checkbox",
   top: 588.796,
   left: 237.04,
   width: 13.68,
   height: 13.680
}
,
{
   page: 2,
   name: "RoofGeneral Warranty is transferable", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 602.385,
   left: 158.64,
   width: 434.76,
   height: 29.880
}
,
{
   page: 2,
   name: "Checkbox RoofGeneral Roof work done while under current roof warranty", 
   isText: false,
   type: "checkbox",
   top: 639.047,
   left: 138.74,
   width: 13.68,
   height: 13.680
}
,
{
   page: 2,
   name: "RoofGeneral Roof work done while under current roof warranty", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 635.52,
   left: 158.88,
   width: 434.28,
   height: 55.20
}
,
{
   page: 2,
   name: "Checkbox RoofGeneral Date work completed", 
   isText: false,
   type: "checkbox",
   top: 695.905,
   left: 138.74,
   width: 13.68,
   height: 13.680
}
,
{
   page: 2,
   name: "RoofGeneral Date work completed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 693.48,
   left: 158.64,
   width: 434.76,
   height: 29.88
}
,
{
   page: 2,
   name: "RoofGeneral Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 725.16,
   left: 33.12,
   width: 101.40,
   height: 28.80
}
,
{
   page: 2,
   name: "Checkbox RoofGeneral Extra Row", 
   isText: false,
   type: "checkbox",
   top: 728.7383,
   left: 138.74,
   width: 13.68,
   height: 13.6800
}
,
{
   page: 2,
   name: "RoofGeneral Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 725.16,
   left: 158.64,
   width: 434.76,
   height: 28.80
}
,
{
   page: 3,
   name: "Checkbox RoofEverExisting Roof leak", 
   isText: false,
   type: "checkbox",
   top: 112.114,
   left: 139.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 3,
   name: "RoofEverExisting Roof leak", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 107.52,
   left: 158.88,
   width: 434.28,
   height: 73.68
}
,
{
   page: 3,
   name: "Checkbox RoofEverExisting Damage to roof", 
   isText: false,
   type: "checkbox",
   top: 190.593,
   left: 139.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 3,
   name: "RoofEverExisting Damage to roof", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 182.88,
   left: 158.88,
   width: 434.28,
   height: 73.68
}
,
{
   page: 3,
   name: "Checkbox RoofEverExisting Damage to skylight", 
   isText: false,
   type: "checkbox",
   top: 261.064,
   left: 139.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 3,
   name: "RoofEverExisting Damage to skylight", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 258.24,
   left: 158.88,
   width: 434.28,
   height: 50.64
}
,
{
   page: 3,
   name: "Checkbox RoofEverExisting Damage to gutter or downspout", 
   isText: false,
   type: "checkbox",
   top: 314.719,
   left: 139.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 3,
   name: "RoofEverExisting Damage to gutter or downspout", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 310.56,
   left: 158.88,
   width: 434.28,
   height: 55.20
}
,
{
   page: 3,
   name: "Checkbox RoofEverExisting Other roof problems issues or concerns", 
   isText: false,
   type: "checkbox",
   top: 372.377,
   left: 139.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 3,
   name: "RoofEverExisting Other roof problems issues or concerns", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 367.44,
   left: 158.88,
   width: 434.28,
   height: 68.88
}
,
{
   page: 3,
   name: "RoofEverExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 437.76,
   left: 33.12,
   width: 101.40,
   height: 27.84
}
,
{
   page: 3,
   name: "Checkbox RoofEverExisting Extra Row", 
   isText: false,
   type: "checkbox",
   top: 441.247,
   left: 139.943,
   width: 14.335,
   height: 13.680
}
,
{
   page: 3,
   name: "RoofEverExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 437.76,
   left: 158.64,
   width: 434.76,
   height: 27.84
}
,
{
   page: 3,
   name: "Checkbox Appliances Builtin vacuum system accessories", 
   isText: false,
   type: "checkbox",
   top: 556.564,
   left: 125.126,
   width: 13.680,
   height: 13.680
}
,
{
   page: 3,
   name: "Age Appliances Builtin vacuum system accessories", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 554.28,
   left: 145.68,
   width: 29.16,
   height: 26.52
}
,
{
   page: 3,
   name: "Appliances Builtin vacuum system accessories", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 553.625,
   left: 177.12,
   width: 416.28,
   height: 26.520
}
,
{
   page: 3,
   name: "Checkbox Appliances Clothes dryer", 
   isText: false,
   type: "checkbox",
   top: 586.194,
   left: 125.126,
   width: 13.680,
   height: 13.680
}
,
{
   page: 3,
   name: "Age Appliances Clothes dryer", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 582.48,
   left: 145.8,
   width: 28.92,
   height: 54.24
}
,
{
   page: 3,
   name: "Checkbox AppliancesClothesWasher Gas", 
   isText: false,
   type: "checkbox",
   top: 580.588,
   left: 179.382,
   width: 13.680,
   height: 13.680
}
,
{
   page: 3,
   name: "Checkbox AppliancesClothesWasher Electric", 
   isText: false,
   type: "checkbox",
   top: 580.588,
   left: 217.821,
   width: 13.680,
   height: 13.680
}
,
{
   page: 3,
   name: "Appliances Clothes dryer", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 594.465,
   left: 177.12,
   width: 416.28,
   height: 40.921
}
,
{
   page: 3,
   name: "Checkbox Appliances Clothes washer", 
   isText: false,
   type: "checkbox",
   top: 643.052,
   left: 125.126,
   width: 13.680,
   height: 13.680
}
,
{
   page: 3,
   name: "Age Appliances Clothes washer", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 638.4,
   left: 145.8,
   width: 28.92,
   height: 56.4
}
,
{
   page: 3,
   name: "Appliances Clothes washer", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 638.52,
   left: 177.36,
   width: 415.80,
   height: 56.28
}
,
{
   page: 3,
   name: "Checkbox Appliances Dishwasher", 
   isText: false,
   type: "checkbox",
   top: 699.9091,
   left: 125.126,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 3,
   name: "Age Appliances Dishwasher", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 697.1345,
   left: 145.8,
   width: 28.92,
   height: 56.4000
}
,
{
   page: 3,
   name: "Appliances Dishwasher", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 696.6,
   left: 177.36,
   width: 415.80,
   height: 56.28
}
,
{
   page: 4,
   name: "Checkbox Appliances Disposal", 
   isText: false,
   type: "checkbox",
   top: 62.463,
   left: 125.927,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Age Appliances Disposal", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 61.2,
   left: 145.8,
   width: 28.92,
   height: 40.08
}
,
{
   page: 4,
   name: "Appliances Disposal", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 61.32,
   left: 177.36,
   width: 415.80,
   height: 39.96
}
,
{
   page: 4,
   name: "Checkbox Appliances Freezer", 
   isText: false,
   type: "checkbox",
   top: 104.906,
   left: 125.927,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Age Appliances Freezer", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 102.96,
   left: 145.8,
   width: 28.92,
   height: 49.44
}
,
{
   page: 4,
   name: "Appliances Freezer", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 103.08,
   left: 177.36,
   width: 415.80,
   height: 49.32
}
,
{
   page: 4,
   name: "Checkbox Appliances Gas grill", 
   isText: false,
   type: "checkbox",
   top: 157.76,
   left: 125.927,
   width: 13.680,
   height: 13.68
}
,
{
   page: 4,
   name: "Age Appliances Gas grill", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 154.08,
   left: 145.8,
   width: 28.92,
   height: 49.44
}
,
{
   page: 4,
   name: "Appliances Gas grill", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 154.2,
   left: 177.36,
   width: 415.80,
   height: 49.32
}
,
{
   page: 4,
   name: "Checkbox Appliances Range ventilation system", 
   isText: false,
   type: "checkbox",
   top: 208.211,
   left: 125.927,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Age Appliances Range ventilation system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 205.2,
   left: 145.8,
   width: 28.92,
   height: 49.44
}
,
{
   page: 4,
   name: "Appliances Range ventilation system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 205.32,
   left: 177.36,
   width: 415.80,
   height: 49.32
}
,
{
   page: 4,
   name: "Checkbox Appliances Microwave oven", 
   isText: false,
   type: "checkbox",
   top: 257.861,
   left: 125.927,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Age Appliances Microwave oven", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 256.32,
   left: 145.8,
   width: 28.92,
   height: 52.56
}
,
{
   page: 4,
   name: "Checkbox AppliancesMicrowaveOven Free standing", 
   isText: false,
   type: "checkbox",
   top: 256.26,
   left: 180.983,
   width: 13.680,
   height: 13.68
}
,
{
   page: 4,
   name: "Checkbox AppliancesMicrowaveOven Built in", 
   isText: false,
   type: "checkbox",
   top: 255.459,
   left: 261.865,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Appliances Microwave oven", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 269.604,
   left: 177.36,
   width: 415.80,
   height: 39.276
}
,
{
   page: 4,
   name: "Checkbox Appliances Oven", 
   isText: false,
   type: "checkbox",
   top: 314.719,
   left: 125.927,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Age Appliances Oven", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 310.56,
   left: 145.8,
   width: 28.92,
   height: 55.68
}
,
{
   page: 4,
   name: "Checkbox AppliancesOven Gas", 
   isText: false,
   type: "checkbox",
   top: 310.715,
   left: 180.183,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Checkbox AppliancesOven Electric", 
   isText: false,
   type: "checkbox",
   top: 310.715,
   left: 212.215,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Checkbox AppliancesOven Single", 
   isText: false,
   type: "checkbox",
   top: 309.914,
   left: 264.268,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Checkbox AppliancesOven Double", 
   isText: false,
   type: "checkbox",
   top: 310.715,
   left: 312.316,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Appliances Oven", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 324.535,
   left: 177.36,
   width: 415.80,
   height: 41.705
}
,
{
   page: 4,
   name: "Checkbox Appliances RangeStove", 
   isText: false,
   type: "checkbox",
   top: 371.576,
   left: 125.927,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Age Appliances RangeStove", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 367.92,
   left: 145.8,
   width: 28.92,
   height: 63.84
}
,
{
   page: 4,
   name: "Checkbox AppliancesRangeStove Gas", 
   isText: false,
   type: "checkbox",
   top: 368.373,
   left: 180.183,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Checkbox AppliancesRangeStove Electric", 
   isText: false,
   type: "checkbox",
   top: 368.373,
   left: 212.215,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Checkbox AppliancesRangeStove Free Standing", 
   isText: false,
   type: "checkbox",
   top: 368.373,
   left: 262.666,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Checkbox AppliancesRangeStove Drop-In", 
   isText: false,
   type: "checkbox",
   top: 368.373,
   left: 337.142,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Appliances RangeStove", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 380.978,
   left: 177.36,
   width: 415.80,
   height: 49.342
}
,
{
   page: 4,
   name: "Checkbox Appliances Refrigerator", 
   isText: false,
   type: "checkbox",
   top: 438.044,
   left: 125.927,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Age Appliances Refrigerator", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 433.44,
   left: 145.8,
   width: 28.92,
   height: 81.60
}
,
{
   page: 4,
   name: "Appliances Refrigerator", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 433.56,
   left: 177.36,
   width: 415.80,
   height: 81.48
}
,
{
   page: 4,
   name: "Checkbox Appliances TV antenna", 
   isText: false,
   type: "checkbox",
   top: 521.328,
   left: 125.927,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Age Appliances TV antenna", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 516.72,
   left: 145.8,
   width: 28.92,
   height: 60.96
}
,
{
   page: 4,
   name: "Checkbox AppliancesTVantenna Owned", 
   isText: false,
   type: "checkbox",
   top: 513.466,
   left: 180.983,
   width: 13.680,
   height: 14.335
}
,
{
   page: 4,
   name: "Checkbox AppliancesTVantenna Leased", 
   isText: false,
   type: "checkbox",
   top: 514.121,
   left: 224.227,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Appliances TV antenna", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 527.066,
   left: 177.36,
   width: 415.80,
   height: 50.614
}
,
{
   page: 4,
   name: "Checkbox Appliances Satellite system", 
   isText: false,
   type: "checkbox",
   top: 582.19,
   left: 125.927,
   width: 13.680,
   height: 13.68
}
,
{
   page: 4,
   name: "Age Appliances Satellite system or DSS dish", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 579.36,
   left: 145.8,
   width: 28.92,
   height: 60.96
}
,
{
   page: 4,
   name: "Checkbox AppliancesSatelliteSystem Owned", 
   isText: false,
   type: "checkbox",
   top: 576.584,
   left: 180.983,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Checkbox AppliancesSatelliteSystem Leased", 
   isText: false,
   type: "checkbox",
   top: 575.783,
   left: 226.63,
   width: 13.68,
   height: 13.680
}
,
{
   page: 4,
   name: "Appliances Satellite system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 589.418,
   left: 177.36,
   width: 415.80,
   height: 49.342
}
,
{
   page: 4,
   name: "Checkbox Appliances Trash compactor", 
   isText: false,
   type: "checkbox",
   top: 644.653,
   left: 125.927,
   width: 13.680,
   height: 13.680
}
,
{
   page: 4,
   name: "Age Appliances Trash compactor", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 642,
   left: 145.8,
   width: 28.92,
   height: 49.44
}
,
{
   page: 4,
   name: "Appliances Trash compactor", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 642.12,
   left: 177.36,
   width: 415.80,
   height: 49.32
}
,
{
   page: 4,
   name: "Appliances Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 693.24,
   left: 36.48,
   width: 84.12,
   height: 35.40
}
,
{
   page: 4,
   name: "Checkbox Appliances Extra Row", 
   isText: false,
   type: "checkbox",
   top: 695.1042,
   left: 125.927,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 4,
   name: "Age Appliances Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 693.12,
   left: 145.8,
   width: 28.92,
   height: 35.52
}
,
{
   page: 4,
   name: "Appliances Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 693.24,
   left: 177.36,
   width: 415.80,
   height: 35.40
}
,
{
   page: 5,
   name: "Checkbox Electrical 220 Volt service", 
   isText: false,
   type: "checkbox",
   top: 139.341,
   left: 143.544,
   width: 14.335,
   height: 13.680
}
,
{
   page: 5,
   name: "Age Electrical 220 Volt service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 134.28,
   left: 164.095,
   width: 33.240,
   height: 53.88
}
,
{
   page: 5,
   name: "Electrical 220 Volt service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 134.28,
   left: 199.44,
   width: 384.36,
   height: 53.88
}
,
{
   page: 5,
   name: "Electrical Amps", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 204.324,
   left: 61.68,
   width: 67.44,
   height: 11.196
}
,
{
   page: 5,
   name: "Checkbox Electrical Electrical Service Amps", 
   isText: false,
   type: "checkbox",
   top: 192.995,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Age Electrical Electrical Service Amps", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 189.96,
   left: 163.44,
   width: 33.24,
   height: 40.20
}
,
{
   page: 5,
   name: "Electrical Electrical Service Amps", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 189.96,
   left: 199.44,
   width: 384.36,
   height: 40.20
}
,
{
   page: 5,
   name: "Checkbox Electrical Landscape lighting", 
   isText: false,
   type: "checkbox",
   top: 237.04,
   left: 143.544,
   width: 13.680,
   height: 13.68
}
,
{
   page: 5,
   name: "Age Electrical Landscape lighting", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 231.96,
   left: 163.44,
   width: 33.24,
   height: 53.88
}
,
{
   page: 5,
   name: "Electrical Landscape lighting", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 231.96,
   left: 199.44,
   width: 384.36,
   height: 53.88
}
,
{
   page: 5,
   name: "Checkbox Electrical Electric provider", 
   isText: false,
   type: "checkbox",
   top: 291.495,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Age Electrical Electric provider", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 287.64,
   left: 163.44,
   width: 33.24,
   height: 40.20
}
,
{
   page: 5,
   name: "Electrical Electric provider", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 287.64,
   left: 199.44,
   width: 384.36,
   height: 40.20
}
,
{
   page: 5,
   name: "Checkbox Electrical CableTV provider", 
   isText: false,
   type: "checkbox",
   top: 331.536,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Age Electrical CableTV provider", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 329.64,
   left: 163.44,
   width: 33.24,
   height: 39.96
}
,
{
   page: 5,
   name: "Electrical CableTV provider", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 329.64,
   left: 199.44,
   width: 384.36,
   height: 39.96
}
,
{
   page: 5,
   name: "Checkbox Electrical Internet provider", 
   isText: false,
   type: "checkbox",
   top: 374.78,
   left: 143.544,
   width: 13.680,
   height: 13.68
}
,
{
   page: 5,
   name: "Age Electrical Internet provider", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 371.4,
   left: 163.44,
   width: 33.24,
   height: 40.2
}
,
{
   page: 5,
   name: "Electrical Internet provider", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 371.4,
   left: 199.44,
   width: 384.36,
   height: 40.2
}
,
{
   page: 5,
   name: "Checkbox Electrical Solar panels", 
   isText: false,
   type: "checkbox",
   top: 416.422,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Age Electrical Solar panels", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 413.4,
   left: 163.44,
   width: 33.24,
   height: 54.6
}
,
{
   page: 5,
   name: "Checkbox ElectricalSolarPanels Owned", 
   isText: false,
   type: "checkbox",
   top: 413.219,
   left: 202.605,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Checkbox ElectricalSolarPanels Leased", 
   isText: false,
   type: "checkbox",
   top: 413.219,
   left: 249.853,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Electrical Solar panels", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 426.92,
   left: 199.44,
   width: 384.36,
   height: 40.20
}
,
{
   page: 5,
   name: "Checkbox Electrical Solar Panels Output", 
   isText: false,
   type: "checkbox",
   top: 473.279,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Age Electrical Solar panels Output", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 469.8,
   left: 163.44,
   width: 33.24,
   height: 40.2
}
,
{
   page: 5,
   name: "Electrical Solar Panels Output", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 469.8,
   left: 199.44,
   width: 384.36,
   height: 40.2
}
,
{
   page: 5,
   name: "Checkbox Electrical Wind generators", 
   isText: false,
   type: "checkbox",
   top: 514.922,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Age Electrical Wind generators", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 511.8,
   left: 163.44,
   width: 33.24,
   height: 40.92
}
,
{
   page: 5,
   name: "Checkbox ElectricalWindGenerators Owned", 
   isText: false,
   type: "checkbox",
   top: 511.718,
   left: 202.605,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Checkbox ElectricalWindGenerators Leased", 
   isText: false,
   type: "checkbox",
   top: 511.718,
   left: 250.654,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Electrical Wind generators", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 523.92,
   left: 199.2,
   width: 384.84,
   height: 28.80
}
,
{
   page: 5,
   name: "Checkbox Electrical Security system", 
   isText: false,
   type: "checkbox",
   top: 557.365,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Age Electrical Security system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 554.52,
   left: 163.44,
   width: 33.24,
   height: 54.60
}
,
{
   page: 5,
   name: "Checkbox ElectricalSecuritySystem Owned", 
   isText: false,
   type: "checkbox",
   top: 554.161,
   left: 201.804,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Checkbox ElectricalSecuritySystem Leased", 
   isText: false,
   type: "checkbox",
   top: 554.161,
   left: 250.654,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Electrical Security system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 567.386,
   left: 199.44,
   width: 384.36,
   height: 41.734
}
,
{
   page: 5,
   name: "Checkbox Electrical Doorbell", 
   isText: false,
   type: "checkbox",
   top: 614.222,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Age Electrical Doorbell", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 610.92,
   left: 163.44,
   width: 33.24,
   height: 53.16
}
,
{
   page: 5,
   name: "Checkbox ElectricalDoorbell Wired", 
   isText: false,
   type: "checkbox",
   top: 611.019,
   left: 201.804,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Checkbox ElectricalDoorbell Wireless", 
   isText: false,
   type: "checkbox",
   top: 611.019,
   left: 255.459,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Checkbox ElectricalDoorbell Smart", 
   isText: false,
   type: "checkbox",
   top: 611.019,
   left: 307.512,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Electrical Doorbell", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 623.786,
   left: 199.44,
   width: 384.36,
   height: 40.294
}
,
{
   page: 5,
   name: "Checkbox Electrical Smokefire detectors", 
   isText: false,
   type: "checkbox",
   top: 668.677,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Age Electrical Smokefire detectors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 665.88,
   left: 163.44,
   width: 33.24,
   height: 39.24
}
,
{
   page: 5,
   name: "Checkbox ElectricalSmokeFireDetectors Battery", 
   isText: false,
   type: "checkbox",
   top: 665.474,
   left: 201.804,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Checkbox ElectricalSmokeFireDetectors Hardwire", 
   isText: false,
   type: "checkbox",
   top: 664.673,
   left: 254.658,
   width: 13.680,
   height: 13.680
}
,
{
   page: 5,
   name: "Electrical Smokefire detectors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 677.338,
   left: 199.2,
   width: 384.84,
   height: 27.782
}
,
{
   page: 5,
   name: "Checkbox Electrical Carbon monoxide alarms", 
   isText: false,
   type: "checkbox",
   top: 709.5189,
   left: 143.544,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 5,
   name: "Age Electrical Carbon monoxide alarms", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 706.92,
   left: 163.44,
   width: 33.24,
   height: 39.24
}
,
{
   page: 5,
   name: "Checkbox ElectricalCarbonMonoxideAlarms Battery", 
   isText: false,
   type: "checkbox",
   top: 706.3156,
   left: 201.804,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 5,
   name: "Checkbox ElectricalCarbonMonoxideAlarms Hardwire", 
   isText: false,
   type: "checkbox",
   top: 706.3156,
   left: 255.459,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 5,
   name: "Electrical Carbon monoxide alarms", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 718.3783,
   left: 199.2,
   width: 384.84,
   height: 27.7817
}
,
{
   page: 6,
   name: "Checkbox Electrical Internet wiring", 
   isText: false,
   type: "checkbox",
   top: 49.65,
   left: 144.146,
   width: 13.680,
   height: 13.025
}
,
{
   page: 6,
   name: "Age Electrical Internet wiring", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.4,
   left: 162.88,
   width: 33.371,
   height: 39.72
}
,
{
   page: 6,
   name: "Checkbox ElectricalInternetWiring Cable", 
   isText: false,
   type: "checkbox",
   top: 47.248,
   left: 201.804,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Checkbox ElectricalInternetWiring DSL", 
   isText: false,
   type: "checkbox",
   top: 48.049,
   left: 243.447,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Checkbox ElectricalInternetWiring Satellite", 
   isText: false,
   type: "checkbox",
   top: 47.248,
   left: 282.686,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Checkbox ElectricalInternetWiring Fiber", 
   isText: false,
   type: "checkbox",
   top: 47.248,
   left: 335.54,
   width: 13.68,
   height: 13.680
}
,
{
   page: 6,
   name: "Checkbox ElectricalInternetWiring Other", 
   isText: false,
   type: "checkbox",
   top: 46.447,
   left: 382.788,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "ElectricalInternetWiring Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 46.8,
   left: 421.2,
   width: 162.0,
   height: 11.76
}
,
{
   page: 6,
   name: "Electrical Internet wiring", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 60,
   left: 199.2,
   width: 384.84,
   height: 27.12
}
,
{
   page: 6,
   name: "Checkbox Electrical Built in sound system", 
   isText: false,
   type: "checkbox",
   top: 91.292,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Age Electrical Built in sound system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 88.44,
   left: 162.88,
   width: 33.371,
   height: 51.436
}
,
{
   page: 6,
   name: "Checkbox ElectricalBuiltInSoundSystem Speakers Built In", 
   isText: false,
   type: "checkbox",
   top: 88.89,
   left: 201.804,
   width: 13.680,
   height: 13.68
}
,
{
   page: 6,
   name: "Checkbox ElectricalBuiltInSoundSystem Wiring Built In", 
   isText: false,
   type: "checkbox",
   top: 88.89,
   left: 293.898,
   width: 13.680,
   height: 13.68
}
,
{
   page: 6,
   name: "Checkbox ElectricalBuiltInSoundSystem Speakers Wireless", 
   isText: false,
   type: "checkbox",
   top: 88.89,
   left: 370.776,
   width: 13.680,
   height: 14.335
}
,
{
   page: 6,
   name: "Electrical Built in sound system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 102.3,
   left: 199.2,
   width: 384.84,
   height: 38.74
}
,
{
   page: 6,
   name: "Electrical Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 143.4,
   left: 33.12,
   width: 105.72,
   height: 26.52
}
,
{
   page: 6,
   name: "Checkbox Electrical Extra Row", 
   isText: false,
   type: "checkbox",
   top: 147.349,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Age Electrical Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 143.885,
   left: 163.201,
   width: 33.065,
   height: 25.662
}
,
{
   page: 6,
   name: "Electrical Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 143.4,
   left: 199.2,
   width: 384.84,
   height: 26.52
}
,
{
   page: 6,
   name: "Checkbox ElectricalNowExisting Security system", 
   isText: false,
   type: "checkbox",
   top: 252.256,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Age ElectricalNowExisting Security system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 250.2,
   left: 163.44,
   width: 33.24,
   height: 53.88
}
,
{
   page: 6,
   name: "ElectricalNowExisting Security system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 250.2,
   left: 199.44,
   width: 384.36,
   height: 53.88
}
,
{
   page: 6,
   name: "Checkbox ElectricalNowExisting Smokefire detectors", 
   isText: false,
   type: "checkbox",
   top: 308.312,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Age ElectricalNowExisting Smokefire detectors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 305.88,
   left: 163.44,
   width: 33.24,
   height: 40.20
}
,
{
   page: 6,
   name: "ElectricalNowExisting Smokefire detectors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 305.88,
   left: 199.44,
   width: 384.36,
   height: 40.20
}
,
{
   page: 6,
   name: "Checkbox ElectricalNowExisting Carbon monoxide alarm", 
   isText: false,
   type: "checkbox",
   top: 351.556,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Age ElectricalNowExisting Carbon monoxide alarm", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 347.88,
   left: 163.44,
   width: 33.24,
   height: 39.96
}
,
{
   page: 6,
   name: "ElectricalNowExisting Carbon monoxide alarm", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 347.88,
   left: 199.44,
   width: 384.36,
   height: 39.96
}
,
{
   page: 6,
   name: "Checkbox ElectricalNowExisting Light fixtures", 
   isText: false,
   type: "checkbox",
   top: 392.398,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Age ElectricalNowExisting Light fixtures", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 389.64,
   left: 163.44,
   width: 33.24,
   height: 40.20
}
,
{
   page: 6,
   name: "ElectricalNowExisting Light fixtures", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 389.64,
   left: 199.44,
   width: 384.36,
   height: 40.20
}
,
{
   page: 6,
   name: "Checkbox ElectricalNowExisting Switches outlets", 
   isText: false,
   type: "checkbox",
   top: 434.04,
   left: 144.146,
   width: 13.680,
   height: 13.68
}
,
{
   page: 6,
   name: "Age ElectricalNowExisting Switches outlets", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 431.64,
   left: 163.44,
   width: 33.24,
   height: 53.88
}
,
{
   page: 6,
   name: "ElectricalNowExisting Switches outlets", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 431.64,
   left: 199.44,
   width: 384.36,
   height: 53.88
}
,
{
   page: 6,
   name: "Checkbox ElectricalNowExisting Internet wiring", 
   isText: false,
   type: "checkbox",
   top: 490.897,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Age ElectricalNowExisting Internet wiring", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 487.32,
   left: 163.44,
   width: 33.24,
   height: 40.20
}
,
{
   page: 6,
   name: "ElectricalNowExisting Internet wiring", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 487.32,
   left: 199.44,
   width: 384.36,
   height: 40.20
}
,
{
   page: 6,
   name: "Checkbox ElectricalNowExisting Inside telephone wiring blocksjacks", 
   isText: false,
   type: "checkbox",
   top: 531.739,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Age ElectricalNowExisting Inside telephone wiring blocksjacks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 529.32,
   left: 163.44,
   width: 33.24,
   height: 39.96
}
,
{
   page: 6,
   name: "ElectricalNowExisting Inside telephone wiring blocksjacks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 529.32,
   left: 199.44,
   width: 384.36,
   height: 39.96
}
,
{
   page: 6,
   name: "Checkbox ElectricalNowExisting Cable TV wiring jacks", 
   isText: false,
   type: "checkbox",
   top: 573.381,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Age ElectricalNowExisting Cable TV wiring jacks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 571.08,
   left: 163.44,
   width: 33.24,
   height: 40.20
}
,
{
   page: 6,
   name: "ElectricalNowExisting Cable TV wiring jacks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 571.08,
   left: 199.44,
   width: 384.36,
   height: 40.20
}
,
{
   page: 6,
   name: "Checkbox ElectricalNowExisting Ceiling fans", 
   isText: false,
   type: "checkbox",
   top: 615.023,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 6,
   name: "Age ElectricalNowExisting Ceiling fans", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.08,
   left: 163.44,
   width: 33.24,
   height: 53.88
}
,
{
   page: 6,
   name: "ElectricalNowExisting Ceiling fans", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 613.08,
   left: 199.44,
   width: 384.36,
   height: 53.88
}
,
{
   page: 6,
   name: "Checkbox ElectricalNowExisting Bathroom vent fans", 
   isText: false,
   type: "checkbox",
   top: 671.08,
   left: 144.146,
   width: 13.680,
   height: 13.68
}
,
{
   page: 6,
   name: "Age ElectricalNowExisting Bathroom vent fans", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 668.76,
   left: 163.44,
   width: 33.24,
   height: 53.88
}
,
{
   page: 6,
   name: "ElectricalNowExisting Bathroom vent fans", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 668.76,
   left: 199.44,
   width: 384.36,
   height: 53.88
}
,
{
   page: 7,
   name: "Number of Remote Controls", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 83.4,
   left: 37.92,
   width: 45.00,
   height: 11.16
}
,
{
   page: 7,
   name: "Checkbox ElectricalNowExisting Garage door opener", 
   isText: false,
   type: "checkbox",
   top: 52.053,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Age ElectricalNowExisting Garage door opener", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.4,
   left: 162.88,
   width: 33.371,
   height: 54.36
}
,
{
   page: 7,
   name: "ElectricalNowExisting Garage door opener", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 48.48,
   left: 199.56,
   width: 390.60,
   height: 53.88
}
,
{
   page: 7,
   name: "Checkbox ElectricalNowExisting Garage door keyless entry", 
   isText: false,
   type: "checkbox",
   top: 107.309,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Age ElectricalNowExisting Garage door keyless entry", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 103.08,
   left: 162.88,
   width: 33.371,
   height: 54.36
}
,
{
   page: 7,
   name: "ElectricalNowExisting Garage door keyless entry", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 104.16,
   left: 199.56,
   width: 390.60,
   height: 52.571
}
,
{
   page: 7,
   name: "Checkbox ElectricalNowExisting Built in intercom system", 
   isText: false,
   type: "checkbox",
   top: 164.967,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Age ElectricalNowExisting Built in intercom system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 158.76,
   left: 162.88,
   width: 33.371,
   height: 40.44
}
,
{
   page: 7,
   name: "ElectricalNowExisting Built in intercom system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 158.4,
   left: 199.56,
   width: 390.60,
   height: 39.48
}
,
{
   page: 7,
   name: "Checkbox ElectricalNowExisting Doorbell", 
   isText: false,
   type: "checkbox",
   top: 204.207,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Age ElectricalNowExisting Doorbell", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 200.52,
   left: 162.88,
   width: 33.371,
   height: 54.36
}
,
{
   page: 7,
   name: "ElectricalNowExisting Doorbell", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 201.6,
   left: 200.215,
   width: 390.600,
   height: 52.571
}
,
{
   page: 7,
   name: "Checkbox ElectricalNowExisting Built in sound system", 
   isText: false,
   type: "checkbox",
   top: 260.264,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Age ElectricalNowExisting Built in sound system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 256.2,
   left: 162.88,
   width: 33.371,
   height: 54.36
}
,
{
   page: 7,
   name: "ElectricalNowExisting Built in sound system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 257.28,
   left: 199.56,
   width: 390.60,
   height: 51.916
}
,
{
   page: 7,
   name: "ElectricalNowExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 312.12,
   left: 33.12,
   width: 105.72,
   height: 26.76
}
,
{
   page: 7,
   name: "Checkbox ElectricalNowExisting Extra Row", 
   isText: false,
   type: "checkbox",
   top: 315.52,
   left: 143.544,
   width: 13.680,
   height: 13.68
}
,
{
   page: 7,
   name: "Age ElectricalNowExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 312.621,
   left: 162.88,
   width: 33.371,
   height: 23.357
}
,
{
   page: 7,
   name: "ElectricalNowExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 312.665,
   left: 199.56,
   width: 390.60,
   height: 25.974
}
,
{
   page: 7,
   name: "Checkbox ElectricalEverExisting Electrical Service", 
   isText: false,
   type: "checkbox",
   top: 437.243,
   left: 141.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Age ElectricalEverExisting Electrical Service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 430.68,
   left: 159.36,
   width: 33.24,
   height: 53.88
}
,
{
   page: 7,
   name: "ElectricalEverExisting Electrical Service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 430.68,
   left: 195.36,
   width: 397.80,
   height: 53.88
}
,
{
   page: 7,
   name: "Checkbox ElectricalEverExisting Aluminum wiring at the outlets 110", 
   isText: false,
   type: "checkbox",
   top: 489.296,
   left: 141.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Age ElectricalEverExisting Aluminum wiring at the outlets 110", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 486.36,
   left: 159.36,
   width: 33.24,
   height: 53.88
}
,
{
   page: 7,
   name: "ElectricalEverExisting Aluminum wiring at the outlets 110", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 486.36,
   left: 195.36,
   width: 397.80,
   height: 53.88
}
,
{
   page: 7,
   name: "Checkbox ElectricalEverExisting Solar panels", 
   isText: false,
   type: "checkbox",
   top: 545.353,
   left: 141.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Age ElectricalEverExisting Solar panels", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 542.04,
   left: 159.36,
   width: 33.24,
   height: 67.80
}
,
{
   page: 7,
   name: "ElectricalEverExisting Solar panels", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 542.04,
   left: 195.36,
   width: 397.80,
   height: 67.80
}
,
{
   page: 7,
   name: "Checkbox ElectricalEverExisting Wind generators", 
   isText: false,
   type: "checkbox",
   top: 615.023,
   left: 141.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Age ElectricalEverExisting Wind generators", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 611.64,
   left: 159.36,
   width: 33.24,
   height: 39.96
}
,
{
   page: 7,
   name: "ElectricalEverExisting Wind generators", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 611.64,
   left: 195.36,
   width: 397.80,
   height: 39.96
}
,
{
   page: 7,
   name: "Checkbox ElectricalEverExisting Electric wiring or panel", 
   isText: false,
   type: "checkbox",
   top: 655.064,
   left: 141.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 7,
   name: "Age ElectricalEverExisting Electric wiring or panel", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 653.4,
   left: 159.36,
   width: 33.24,
   height: 53.88
}
,
{
   page: 7,
   name: "ElectricalEverExisting Electric wiring or panel", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 653.4,
   left: 195.36,
   width: 397.80,
   height: 53.88
}
,
{
   page: 7,
   name: "ElectricalEverExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 709.08,
   left: 33.36,
   width: 105.24,
   height: 36.84
}
,
{
   page: 7,
   name: "Checkbox ElectricalEverExisting Extra Row", 
   isText: false,
   type: "checkbox",
   top: 712.5759,
   left: 142.598,
   width: 13.025,
   height: 13.0254
}
,
{
   page: 7,
   name: "Age ElectricalEverExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 709.08,
   left: 159.36,
   width: 33.24,
   height: 36.84
}
,
{
   page: 7,
   name: "ElectricalEverExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 709.08,
   left: 195.36,
   width: 397.80,
   height: 36.84
}
,
{
   page: 8,
   name: "Checkbox MechanicalNowExisting Overhead doors including garage doors", 
   isText: false,
   type: "checkbox",
   top: 123.325,
   left: 129.731,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Age MechanicalNowExisting Overhead doors including garage doors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 118.2,
   left: 149.88,
   width: 37.68,
   height: 54.36
}
,
{
   page: 8,
   name: "MechanicalNowExisting Overhead doors including garage doors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 118.2,
   left: 190.44,
   width: 402.24,
   height: 54.36
}
,
{
   page: 8,
   name: "Checkbox MechanicalNowExisting Entry gate system", 
   isText: false,
   type: "checkbox",
   top: 179.382,
   left: 129.731,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Age MechanicalNowExisting Entry gate system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 175.08,
   left: 149.88,
   width: 37.68,
   height: 54.60
}
,
{
   page: 8,
   name: "MechanicalNowExisting Entry gate system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 175.08,
   left: 190.44,
   width: 402.24,
   height: 54.60
}
,
{
   page: 8,
   name: "Checkbox MechanicalNowExisting Elevator", 
   isText: false,
   type: "checkbox",
   top: 237.04,
   left: 129.731,
   width: 13.680,
   height: 13.68
}
,
{
   page: 8,
   name: "Age MechanicalNowExisting Elevator", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 232.2,
   left: 149.88,
   width: 37.68,
   height: 68.52
}
,
{
   page: 8,
   name: "MechanicalNowExisting Elevator", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 232.2,
   left: 190.44,
   width: 402.24,
   height: 68.52
}
,
{
   page: 8,
   name: "Number of Sump pumps", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 316.193,
   left: 52.8,
   width: 59.04,
   height: 10.447
}
,
{
   page: 8,
   name: "Checkbox MechanicalNowExisting Sump pumps", 
   isText: false,
   type: "checkbox",
   top: 306.711,
   left: 129.731,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Age MechanicalNowExisting Sump pumps", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 303.24,
   left: 150.535,
   width: 37.680,
   height: 54.60
}
,
{
   page: 8,
   name: "MechanicalNowExisting Sump pumps", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 303.24,
   left: 190.44,
   width: 402.24,
   height: 54.60
}
,
{
   page: 8,
   name: "Checkbox MechanicalNowExisting Recycle pump", 
   isText: false,
   type: "checkbox",
   top: 361.967,
   left: 129.731,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Age MechanicalNowExisting Recycle pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 360.36,
   left: 149.88,
   width: 37.68,
   height: 40.68
}
,
{
   page: 8,
   name: "MechanicalNowExisting Recycle pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 361.015,
   left: 190.44,
   width: 402.24,
   height: 40.680
}
,
{
   page: 8,
   name: "MechanicalNowExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 403.32,
   left: 32.64,
   width: 92.28,
   height: 27.24
}
,
{
   page: 8,
   name: "Checkbox MechanicalNowExisting Extra Row", 
   isText: false,
   type: "checkbox",
   top: 405.211,
   left: 129.731,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Age MechanicalNowExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 403.32,
   left: 149.64,
   width: 38.16,
   height: 27.24
}
,
{
   page: 8,
   name: "MechanicalNowExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 403.32,
   left: 190.2,
   width: 402.72,
   height: 27.24
}
,
{
   page: 8,
   name: "Checkbox HVAC Furnace Yes", 
   isText: false,
   type: "checkbox",
   top: 535.743,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Age HVAC Furnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 532.44,
   left: 163.56,
   width: 37.68,
   height: 82.20
}
,
{
   page: 8,
   name: "HVAC Furnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 532.44,
   left: 204.12,
   width: 389.04,
   height: 82.20
}
,
{
   page: 8,
   name: "Checkbox HVAC Furance Type", 
   isText: false,
   type: "checkbox",
   top: 620.629,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Age HVAC Furnace Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 617.16,
   left: 163.56,
   width: 37.68,
   height: 84.36
}
,
{
   page: 8,
   name: "Checkbox HVACFurnaceType Forced Air Gas", 
   isText: false,
   type: "checkbox",
   top: 616.426,
   left: 205.008,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Checkbox HVACFurnaceType Forced Air Electric", 
   isText: false,
   type: "checkbox",
   top: 616.426,
   left: 289.093,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Checkbox HVACFurnaceType Forced Air Propane", 
   isText: false,
   type: "checkbox",
   top: 629.438,
   left: 205.008,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Checkbox HVACFurnaceType Radiant", 
   isText: false,
   type: "checkbox",
   top: 629.438,
   left: 297.101,
   width: 13.025,
   height: 14.335
}
,
{
   page: 8,
   name: "Checkbox HVACFurnaceType Gravity Flow", 
   isText: false,
   type: "checkbox",
   top: 629.438,
   left: 346.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "Checkbox HVACFurnaceType Other", 
   isText: false,
   type: "checkbox",
   top: 629.438,
   left: 416.422,
   width: 13.680,
   height: 13.680
}
,
{
   page: 8,
   name: "HVAC Furnace Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 644.708,
   left: 204.12,
   width: 389.04,
   height: 55.132
}
,
{
   page: 8,
   name: "Checkbox HVAC Furnace Number of Units", 
   isText: false,
   type: "checkbox",
   top: 707.1164,
   left: 140.943,
   width: 14.990,
   height: 13.6800
}
,
{
   page: 8,
   name: "Age HVAC Furnace Number of Units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 704.04,
   left: 163.56,
   width: 37.68,
   height: 50.04
}
,
{
   page: 8,
   name: "HVAC Furnace Number of Units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 704.04,
   left: 204.12,
   width: 389.04,
   height: 50.04
}
,
{
   page: 9,
   name: "Checkbox HVAC Furnace Zoned", 
   isText: false,
   type: "checkbox",
   top: 139.854,
   left: 141.142,
   width: 13.680,
   height: 13.680
}
,
{
   page: 9,
   name: "Age HVAC Zoned", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 135.24,
   left: 163.56,
   width: 36.916,
   height: 141.36
}
,
{
   page: 9,
   name: "HVAC Furnace Location Zone 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 142.737,
   left: 204.12,
   width: 389.04,
   height: 49.211
}
,
{
   page: 9,
   name: "HVAC Furnace Location Zone 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 200.032,
   left: 204.12,
   width: 389.04,
   height: 43.320
}
,
{
   page: 9,
   name: "HVAC Furnace Location Zone 3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 251.301,
   left: 204.12,
   width: 389.04,
   height: 23.683
}
,
{
   page: 9,
   name: "Checkbox HVAC Heating system other than furnace", 
   isText: false,
   type: "checkbox",
   top: 282.398,
   left: 141.142,
   width: 13.680,
   height: 13.680
}
,
{
   page: 9,
   name: "Age HVAC Heating system other than furnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 278.76,
   left: 163.56,
   width: 36.916,
   height: 54.96
}
,
{
   page: 9,
   name: "HVAC Heating system other than furnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 279.12,
   left: 204.12,
   width: 389.04,
   height: 54.60
}
,
{
   page: 9,
   name: "Checkbox HVAC Heating system Type", 
   isText: false,
   type: "checkbox",
   top: 342.459,
   left: 141.142,
   width: 13.680,
   height: 13.680
}
,
{
   page: 9,
   name: "Age HVAC Heating system Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 335.88,
   left: 163.56,
   width: 36.916,
   height: 54.96
}
,
{
   page: 9,
   name: "HVAC Heating system Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 336.24,
   left: 204.12,
   width: 389.04,
   height: 54.60
}
,
{
   page: 9,
   name: "Checkbox HVAC Fireplace", 
   isText: false,
   type: "checkbox",
   top: 396.113,
   left: 141.797,
   width: 13.025,
   height: 13.680
}
,
{
   page: 9,
   name: "Age HVAC Fireplace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 393.0,
   left: 163.56,
   width: 36.916,
   height: 54.96
}
,
{
   page: 9,
   name: "HVAC Fireplace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 393.36,
   left: 204.12,
   width: 389.04,
   height: 54.60
}
,
{
   page: 9,
   name: "Checkbox HVAC Fireplace Type", 
   isText: false,
   type: "checkbox",
   top: 454.572,
   left: 141.142,
   width: 13.680,
   height: 13.680
}
,
{
   page: 9,
   name: "Age HVAC Fireplace Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 450.12,
   left: 163.56,
   width: 36.916,
   height: 54.00
}
,
{
   page: 9,
   name: "Checkbox HVACFireplaceType Masonry", 
   isText: false,
   type: "checkbox",
   top: 451.028,
   left: 206.245,
   width: 12.908,
   height: 11.890
}
,
{
   page: 9,
   name: "Checkbox HVACFireplaceType Insert", 
   isText: false,
   type: "checkbox",
   top: 451.028,
   left: 256.105,
   width: 12.909,
   height: 11.890
}
,
{
   page: 9,
   name: "Checkbox HVACFireplaceType Wood Burning", 
   isText: false,
   type: "checkbox",
   top: 451.028,
   left: 295.274,
   width: 12.908,
   height: 11.890
}
,
{
   page: 9,
   name: "Checkbox HVACFireplaceType Direct Vent", 
   isText: false,
   type: "checkbox",
   top: 451.028,
   left: 368.083,
   width: 12.909,
   height: 11.890
}
,
{
   page: 9,
   name: "Checkbox HVACFireplaceType Other", 
   isText: false,
   type: "checkbox",
   top: 451.028,
   left: 428.654,
   width: 12.909,
   height: 11.890
}
,
{
   page: 9,
   name: "HVAC Fireplace Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 463.564,
   left: 204.12,
   width: 389.04,
   height: 41.357
}
,
{
   page: 9,
   name: "Checkbox HVAC Fireplace starter", 
   isText: false,
   type: "checkbox",
   top: 509.828,
   left: 141.142,
   width: 13.680,
   height: 13.680
}
,
{
   page: 9,
   name: "Age HVAC Fireplace starter", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 506.28,
   left: 163.56,
   width: 36.916,
   height: 54.24
}
,
{
   page: 9,
   name: "Checkbox HVACFireplaceStarter Switch", 
   isText: false,
   type: "checkbox",
   top: 506.544,
   left: 207.226,
   width: 12.400,
   height: 11.891
}
,
{
   page: 9,
   name: "Checkbox HVACFireplaceStarter Remote", 
   isText: false,
   type: "checkbox",
   top: 506.544,
   left: 254.032,
   width: 12.399,
   height: 11.891
}
,
{
   page: 9,
   name: "HVAC Fireplace starter", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 518.924,
   left: 204.12,
   width: 389.04,
   height: 41.596
}
,
{
   page: 9,
   name: "Checkbox HVAC Free Standing Heating Stove", 
   isText: false,
   type: "checkbox",
   top: 568.576,
   left: 141.142,
   width: 13.680,
   height: 13.680
}
,
{
   page: 9,
   name: "Age HVAC Free Standing Heating Stove", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 563.88,
   left: 163.56,
   width: 37.68,
   height: 68.28
}
,
{
   page: 9,
   name: "CommentsFree Standing Heating Stove", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 563.88,
   left: 204.12,
   width: 389.04,
   height: 68.28
}
,
{
   page: 9,
   name: "Checkbox HVAC Freestanding Heating Stove Fuel Source", 
   isText: false,
   type: "checkbox",
   top: 639.047,
   left: 141.142,
   width: 13.680,
   height: 13.680
}
,
{
   page: 9,
   name: "Age HVAC Freestanding Heating Stove Fuel Source", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 634.68,
   left: 163.56,
   width: 37.68,
   height: 57.24
}
,
{
   page: 9,
   name: "Checkbox HVACFreeStandingFuelSource Wood", 
   isText: false,
   type: "checkbox",
   top: 633.881,
   left: 206.717,
   width: 12.909,
   height: 12.399
}
,
{
   page: 9,
   name: "Checkbox HVACFreeStandingFuelSource Pellet", 
   isText: false,
   type: "checkbox",
   top: 633.881,
   left: 247.941,
   width: 12.908,
   height: 12.399
}
,
{
   page: 9,
   name: "Checkbox HVACFreeStandingFuelSource Corn", 
   isText: false,
   type: "checkbox",
   top: 633.881,
   left: 287.655,
   width: 12.908,
   height: 12.399
}
,
{
   page: 9,
   name: "Checkbox HVACFreeStandingFuelSource Gas", 
   isText: false,
   type: "checkbox",
   top: 633.881,
   left: 324.314,
   width: 12.908,
   height: 12.399
}
,
{
   page: 9,
   name: "Checkbox HVACFreeStandingFuelSource Other", 
   isText: false,
   type: "checkbox",
   top: 633.881,
   left: 357.409,
   width: 12.909,
   height: 12.399
}
,
{
   page: 9,
   name: "Freestanding Heating Stove Fuel Source", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 645.48,
   left: 204.12,
   width: 389.04,
   height: 46.44
}
,
{
   page: 9,
   name: "chimneyflue last cleaned", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 718.5928,
   left: 37.92,
   width: 92.40,
   height: 16.7672
}
,
{
   page: 9,
   name: "Checkbox HVAC Date Fireplace Last Cleaned", 
   isText: false,
   type: "checkbox",
   top: 698.3075,
   left: 141.142,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 9,
   name: "Age HVAC Date fireplace last cleaned", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 694.44,
   left: 163.56,
   width: 37.68,
   height: 54.12
}
,
{
   page: 9,
   name: "Checkbox HVAC Date fireplace last clean Do not know", 
   isText: false,
   type: "checkbox",
   top: 694.4886,
   left: 206.208,
   width: 12.909,
   height: 11.3810
}
,
{
   page: 9,
   name: "HVAC Date fireplace last cleaned", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 705,
   left: 204.12,
   width: 389.04,
   height: 43.56
}
,
{
   page: 10,
   name: "Checkbox HVAC Fuel tanks", 
   isText: false,
   type: "checkbox",
   top: 141.654,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 10,
   name: "Age HVAC Fuel tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 136.24,
   left: 163.56,
   width: 38.226,
   height: 67.92
}
,
{
   page: 10,
   name: "Checkbox Fuel tanks Owned", 
   isText: false,
   type: "checkbox",
   top: 135.351,
   left: 208.681,
   width: 11.890,
   height: 12.909
}
,
{
   page: 10,
   name: "Checkbox Fuel tanks Leased", 
   isText: false,
   type: "checkbox",
   top: 135.351,
   left: 253.486,
   width: 11.891,
   height: 12.909
}
,
{
   page: 10,
   name: "HVAC Fuel tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 146.92,
   left: 204.12,
   width: 389.04,
   height: 57.24
}
,
{
   page: 10,
   name: "Checkbox HVAC Radiant heating system", 
   isText: false,
   type: "checkbox",
   top: 208.122,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 10,
   name: "Age HVAC Radiant heating system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 205.44,
   left: 163.68,
   width: 38.226,
   height: 26.28
}
,
{
   page: 10,
   name: "Checkbox HVACRadiantHeatingSystem Interior", 
   isText: false,
   type: "checkbox",
   top: 206.633,
   left: 205.699,
   width: 12.908,
   height: 12.400
}
,
{
   page: 10,
   name: "Checkbox HVACRadiantHeatingSystem Exterior", 
   isText: false,
   type: "checkbox",
   top: 206.633,
   left: 254.505,
   width: 12.908,
   height: 12.400
}
,
{
   page: 10,
   name: "HVAC Radiant heating system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 204.247,
   left: 307.439,
   width: 285.721,
   height: 27.175
}
,
{
   page: 10,
   name: "Checkbox HVAC RadiantHeatingSystem Interior Type", 
   isText: false,
   type: "checkbox",
   top: 238.552,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 10,
   name: "Age HVAC RadiantHeatingSystem Interior Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 233.88,
   left: 163.56,
   width: 38.226,
   height: 54.96
}
,
{
   page: 10,
   name: "HVAC RadiantHeatingSystem Interior Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 234.222,
   left: 204.12,
   width: 389.04,
   height: 55.618
}
,
{
   page: 10,
   name: "Checkbox HVAC RadiantHeatingSystem Exterior Type", 
   isText: false,
   type: "checkbox",
   top: 294.588,
   left: 140.142,
   width: 13.680,
   height: 14.502
}
,
{
   page: 10,
   name: "Age HVAC RadiantHeatingSystem Exterior Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 291.0,
   left: 163.56,
   width: 38.226,
   height: 53.651
}
,
{
   page: 10,
   name: "HVAC RadiantHeatingSystem Exterior Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.36,
   left: 204.12,
   width: 389.04,
   height: 54.60
}
,
{
   page: 10,
   name: "Checkbox HVAC Air Conditioning", 
   isText: false,
   type: "checkbox",
   top: 355.56,
   left: 140.943,
   width: 13.680,
   height: 13.68
}
,
{
   page: 10,
   name: "Age HVAC Air Conditioning", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 349.32,
   left: 163.56,
   width: 37.68,
   height: 91.32
}
,
{
   page: 10,
   name: "HVAC Air Conditioning", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 349.32,
   left: 204.12,
   width: 389.04,
   height: 91.32
}
,
{
   page: 10,
   name: "Checkbox HVAC Air Conditioning Type", 
   isText: false,
   type: "checkbox",
   top: 447.654,
   left: 141.744,
   width: 13.680,
   height: 13.679
}
,
{
   page: 10,
   name: "Age HVAC Air Conditioning Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 443.16,
   left: 163.56,
   width: 37.68,
   height: 66.84
}
,
{
   page: 10,
   name: "Checkbox HVACAirConditioningType Electric", 
   isText: false,
   type: "checkbox",
   top: 441.42,
   left: 208.263,
   width: 12.399,
   height: 13.417
}
,
{
   page: 10,
   name: "Checkbox HVACAirConditioningType Central Air", 
   isText: false,
   type: "checkbox",
   top: 441.42,
   left: 258.087,
   width: 12.399,
   height: 13.417
}
,
{
   page: 10,
   name: "Checkbox HVACAirConditioningType Other", 
   isText: false,
   type: "checkbox",
   top: 441.42,
   left: 327.387,
   width: 12.400,
   height: 13.417
}
,
{
   page: 10,
   name: "HVAC Air Conditioning Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 454.727,
   left: 204.12,
   width: 389.04,
   height: 54.113
}
,
{
   page: 10,
   name: "Checkbox HVAC Air Conditioning Number of Units", 
   isText: false,
   type: "checkbox",
   top: 515.722,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 10,
   name: "Age HVAC Air Conditioning Number of Units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 512.52,
   left: 163.56,
   width: 37.68,
   height: 50.04
}
,
{
   page: 10,
   name: "HVAC Air Conditioning Number of Units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 512.52,
   left: 204.12,
   width: 389.04,
   height: 50.04
}
,
{
   page: 10,
   name: "Checkbox HVAC Air Conditioning Zoned", 
   isText: false,
   type: "checkbox",
   top: 568.576,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 10,
   name: "Age HVAC Air Conditioning Zoned", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 565.08,
   left: 163.56,
   width: 37.68,
   height: 141.00
}
,
{
   page: 10,
   name: "HVAC Air Conditioning Location of zone 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 573.884,
   left: 203.324,
   width: 390.372,
   height: 44.487
}
,
{
   page: 10,
   name: "HVAC Air Conditioning Location of zone 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 625.233,
   left: 203.324,
   width: 390.372,
   height: 44.487
}
,
{
   page: 10,
   name: "HVAC Air Conditioning Location of zone 3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 677.771,
   left: 204.12,
   width: 389.04,
   height: 27.6107
}
,
{
   page: 10,
   name: "HVAC Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 708.6,
   left: 33.36,
   width: 100.68,
   height: 36.12
}
,
{
   page: 10,
   name: "Checkbox HVAC Extra Row", 
   isText: false,
   type: "checkbox",
   top: 711.1205,
   left: 140.943,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 10,
   name: "Age HVAC Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 708.6,
   left: 163.56,
   width: 37.68,
   height: 36.12
}
,
{
   page: 10,
   name: "HVAC Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 708.6,
   left: 204.12,
   width: 389.04,
   height: 36.12
}
,
{
   page: 11,
   name: "Checkbox HVACProblemsNowExisting Furnace", 
   isText: false,
   type: "checkbox",
   top: 132.134,
   left: 141.744,
   width: 13.680,
   height: 13.680
}
,
{
   page: 11,
   name: "Age HVACProblemsNowExisting Furnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 128.28,
   left: 163.56,
   width: 37.68,
   height: 87.96
}
,
{
   page: 11,
   name: "HVACProblemsNowExisting Furnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 128.28,
   left: 204.12,
   width: 389.04,
   height: 87.96
}
,
{
   page: 11,
   name: "Checkbox HVACProblemsNowExisting Heating System other than Furnace", 
   isText: false,
   type: "checkbox",
   top: 222.625,
   left: 141.744,
   width: 13.680,
   height: 13.680
}
,
{
   page: 11,
   name: "Age HVACProblemsNowExisting Heating System other than Furnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.76,
   left: 163.56,
   width: 37.68,
   height: 77.64
}
,
{
   page: 11,
   name: "HVACProblemsNowExisting Heating System other than Furnace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.76,
   left: 204.12,
   width: 389.04,
   height: 77.64
}
,
{
   page: 11,
   name: "Checkbox HVACProblemsNowExisting Heat Pump", 
   isText: false,
   type: "checkbox",
   top: 302.707,
   left: 141.744,
   width: 13.680,
   height: 13.680
}
,
{
   page: 11,
   name: "Age HVACProblemsNowExisting Heat Pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 298.92,
   left: 163.56,
   width: 37.68,
   height: 77.64
}
,
{
   page: 11,
   name: "HVACProblemsNowExisting Heat Pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 298.92,
   left: 204.12,
   width: 389.04,
   height: 77.64
}
,
{
   page: 11,
   name: "Checkbox HVACProblemsNowExisting Evaporative cooler", 
   isText: false,
   type: "checkbox",
   top: 383.589,
   left: 141.744,
   width: 13.680,
   height: 13.680
}
,
{
   page: 11,
   name: "Age HVACProblemsNowExisting Evaporative cooler", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 379.08,
   left: 163.56,
   width: 37.68,
   height: 77.40
}
,
{
   page: 11,
   name: "HVACProblemsNowExisting Evaporative cooler", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 379.08,
   left: 204.12,
   width: 389.04,
   height: 77.40
}
,
{
   page: 11,
   name: "Checkbox HVACProblemsNowExisting Window air conditioning units", 
   isText: false,
   type: "checkbox",
   top: 464.471,
   left: 141.744,
   width: 13.680,
   height: 13.680
}
,
{
   page: 11,
   name: "Age HVACProblemsNowExisting Window air conditioning units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459,
   left: 163.56,
   width: 37.68,
   height: 77.64
}
,
{
   page: 11,
   name: "HVACProblemsNowExisting Window air conditioning units", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459,
   left: 204.12,
   width: 389.04,
   height: 77.64
}
,
{
   page: 11,
   name: "Checkbox HVACProblemsNowExisting Central air conditioning", 
   isText: false,
   type: "checkbox",
   top: 543.751,
   left: 141.744,
   width: 13.680,
   height: 13.680
}
,
{
   page: 11,
   name: "Age HVACProblemsNowExisting Central air conditioning", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 539.16,
   left: 163.56,
   width: 37.68,
   height: 91.32
}
,
{
   page: 11,
   name: "HVACProblemsNowExisting Central air conditioning", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 539.16,
   left: 204.12,
   width: 389.04,
   height: 91.32
}
,
{
   page: 11,
   name: "Checkbox HVACProblemsNowExistingAttic ventilation system attic only", 
   isText: false,
   type: "checkbox",
   top: 637.446,
   left: 141.744,
   width: 13.680,
   height: 13.680
}
,
{
   page: 11,
   name: "Age HVACProblemsNowExistingAttic ventilation system attic only", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 633,
   left: 163.56,
   width: 37.68,
   height: 50.04
}
,
{
   page: 11,
   name: "HVACProblemsNowExistingAttic ventilation system attic only", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 633,
   left: 204.12,
   width: 389.04,
   height: 50.04
}
,
{
   page: 11,
   name: "Checkbox HVACProblemsNowExisting Whole house fan", 
   isText: false,
   type: "checkbox",
   top: 690.299,
   left: 141.744,
   width: 13.680,
   height: 13.6804
}
,
{
   page: 11,
   name: "Age HVACProblemsNowExisting Whole house fan", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 685.56,
   left: 163.56,
   width: 37.68,
   height: 63.72
}
,
{
   page: 11,
   name: "HVACProblemsNowExisting Whole house fan", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 685.56,
   left: 204.12,
   width: 389.04,
   height: 63.72
}
,
{
   page: 12,
   name: "Checkbox HVACProblemsNowExisting Vent fans", 
   isText: false,
   type: "checkbox",
   top: 92.093,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 12,
   name: "Age HVACProblemsNowExisting Vent fans", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 86.28,
   left: 163.56,
   width: 37.68,
   height: 77.64
}
,
{
   page: 12,
   name: "HVACProblemsNowExisting Vent fans", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 86.28,
   left: 204.12,
   width: 389.04,
   height: 77.64
}
,
{
   page: 12,
   name: "Checkbox HVACProblemsNowExisting Humidifier", 
   isText: false,
   type: "checkbox",
   top: 171.374,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 12,
   name: "Age HVACProblemsNowExisting Humidifier", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 166.44,
   left: 163.56,
   width: 37.68,
   height: 77.64
}
,
{
   page: 12,
   name: "HVACProblemsNowExisting Humidifier", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 166.44,
   left: 204.12,
   width: 389.04,
   height: 77.64
}
,
{
   page: 12,
   name: "Checkbox HVACProblemsNowExisting Air purifier", 
   isText: false,
   type: "checkbox",
   top: 251.455,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 12,
   name: "Age HVACProblemsNowExisting Air purifier", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 246.6,
   left: 163.56,
   width: 37.68,
   height: 77.4
}
,
{
   page: 12,
   name: "HVACProblemsNowExisting Air purifier", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 246.6,
   left: 204.12,
   width: 389.04,
   height: 77.4
}
,
{
   page: 12,
   name: "Checkbox HVACProblemsNowExisting Fireplace", 
   isText: false,
   type: "checkbox",
   top: 330.735,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 12,
   name: "Age HVACProblemsNowExisting Fireplace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 326.52,
   left: 163.56,
   width: 37.68,
   height: 91.56
}
,
{
   page: 12,
   name: "HVACProblemsNowExisting Fireplace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 326.52,
   left: 204.12,
   width: 389.04,
   height: 91.56
}
,
{
   page: 12,
   name: "Checkbox HVACProblemsNowExisting Fireplace insert", 
   isText: false,
   type: "checkbox",
   top: 425.231,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 12,
   name: "Age HVACProblemsNowExisting Fireplace insert", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 420.6,
   left: 163.56,
   width: 37.68,
   height: 77.4
}
,
{
   page: 12,
   name: "HVACProblemsNowExisting Fireplace insert", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 420.6,
   left: 204.12,
   width: 389.04,
   height: 77.4
}
,
{
   page: 12,
   name: "Checkbox HVACProblemsNowExisting Fireplace starter", 
   isText: false,
   type: "checkbox",
   top: 505.312,
   left: 140.943,
   width: 13.680,
   height: 13.680
}
,
{
   page: 12,
   name: "Age HVACProblemsNowExisting Fireplace starter", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 500.52,
   left: 163.56,
   width: 37.68,
   height: 63.72
}
,
{
   page: 12,
   name: "HVACProblemsNowExisting Fireplace starter", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 500.52,
   left: 204.12,
   width: 389.04,
   height: 63.72
}
,
{
   page: 12,
   name: "Checkbox HVACProblemsNowExisting Heating Stove", 
   isText: false,
   type: "checkbox",
   top: 572.58,
   left: 140.943,
   width: 13.680,
   height: 13.68
}
,
{
   page: 12,
   name: "Age HVACProblemsNowExisting Heating Stove", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 566.76,
   left: 163.56,
   width: 37.68,
   height: 77.64
}
,
{
   page: 12,
   name: "HVACProblemsNowExisting Heating Stove", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 566.76,
   left: 204.12,
   width: 389.04,
   height: 77.64
}
,
{
   page: 12,
   name: "Checkbox HVACProblemsNowExisting Fuel tanks", 
   isText: false,
   type: "checkbox",
   top: 651.06,
   left: 140.943,
   width: 13.680,
   height: 13.68
}
,
{
   page: 12,
   name: "Age HVACProblemsNowExisting Fuel tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 646.92,
   left: 163.56,
   width: 37.68,
   height: 63.72
}
,
{
   page: 12,
   name: "HVACProblemsNowExisting Fuel tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 646.92,
   left: 204.12,
   width: 389.04,
   height: 63.72
}
,
{
   page: 12,
   name: "HVACProblemsNowExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 712.92,
   left: 33.12,
   width: 101.16,
   height: 27.24
}
,
{
   page: 12,
   name: "Checkbox HVACProblemsNowExisting Extra Row", 
   isText: false,
   type: "checkbox",
   top: 715.1245,
   left: 140.943,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 12,
   name: "Age HVACProblemsNowExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 712.92,
   left: 163.32,
   width: 38.16,
   height: 27.24
}
,
{
   page: 12,
   name: "HVACProblemsNowExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 712.92,
   left: 203.88,
   width: 389.52,
   height: 27.24
}
,
{
   page: 13,
   name: "Checkbox Water Heater", 
   isText: false,
   type: "checkbox",
   top: 145.748,
   left: 132.935,
   width: 12.858,
   height: 13.680
}
,
{
   page: 13,
   name: "Age Water heater", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 142.8,
   left: 154.56,
   width: 28.80,
   height: 54.0
}
,
{
   page: 13,
   name: "Water heater", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 142.92,
   left: 186.12,
   width: 407.04,
   height: 53.88
}
,
{
   page: 13,
   name: "Checkbox Number of water heaters", 
   isText: false,
   type: "checkbox",
   top: 202.605,
   left: 132.935,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Age Number of water heaters", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 199.402,
   left: 154.557,
   width: 28.276,
   height: 32.411
}
,
{
   page: 13,
   name: "Number of water heaters", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 198.6,
   left: 186.12,
   width: 407.04,
   height: 35.4
}
,
{
   page: 13,
   name: "Checkbox Water Heater Fuel Type", 
   isText: false,
   type: "checkbox",
   top: 238.642,
   left: 132.935,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Age Water Heater Fuel Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 235.68,
   left: 154.56,
   width: 28.80,
   height: 54.24
}
,
{
   page: 13,
   name: "Water Heater Fuel Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 235.8,
   left: 186.12,
   width: 407.04,
   height: 54.12
}
,
{
   page: 13,
   name: "Checkbox Water Heater Capacity", 
   isText: false,
   type: "checkbox",
   top: 295.499,
   left: 132.935,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Age Water Heater Capacity", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 291.6,
   left: 154.56,
   width: 28.80,
   height: 49.2
}
,
{
   page: 13,
   name: "Water Heater Capacity", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 291.72,
   left: 186.12,
   width: 407.04,
   height: 49.08
}
,
{
   page: 13,
   name: "Checkbox Water filter system", 
   isText: false,
   type: "checkbox",
   top: 346.751,
   left: 132.935,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Age Water filter system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 342.48,
   left: 154.56,
   width: 28.80,
   height: 52.08
}
,
{
   page: 13,
   name: "Checkbox WaterFilterSystem Owned", 
   isText: false,
   type: "checkbox",
   top: 341.946,
   left: 188.991,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Checkbox WaterFilterSystem Leased", 
   isText: false,
   type: "checkbox",
   top: 340.345,
   left: 233.837,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Water filter system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 354.122,
   left: 186.12,
   width: 407.04,
   height: 40.438
}
,
{
   page: 13,
   name: "Checkbox Water softener", 
   isText: false,
   type: "checkbox",
   top: 401.206,
   left: 132.935,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Age Water softener", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 396.24,
   left: 154.56,
   width: 28.80,
   height: 52.08
}
,
{
   page: 13,
   name: "Checkbox WaterSoftener Owned", 
   isText: false,
   type: "checkbox",
   top: 394.8,
   left: 188.991,
   width: 13.680,
   height: 13.68
}
,
{
   page: 13,
   name: "Checkbox WaterSoftener Leased", 
   isText: false,
   type: "checkbox",
   top: 395.601,
   left: 238.642,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Water Softener", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 408.582,
   left: 186.12,
   width: 407.04,
   height: 38.258
}
,
{
   page: 13,
   name: "Checkbox Location of master water shutoff", 
   isText: false,
   type: "checkbox",
   top: 454.861,
   left: 132.935,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Age Location of master water shutoff", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 450,
   left: 154.56,
   width: 28.80,
   height: 54
}
,
{
   page: 13,
   name: "Location of master water shutoff", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 450.12,
   left: 186.12,
   width: 407.04,
   height: 53.88
}
,
{
   page: 13,
   name: "Checkbox Type of well", 
   isText: false,
   type: "checkbox",
   top: 509.316,
   left: 132.935,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Age Type of well", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 505.68,
   left: 154.56,
   width: 28.80,
   height: 54.00
}
,
{
   page: 13,
   name: "Type of well", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 505.8,
   left: 186.12,
   width: 407.04,
   height: 53.88
}
,
{
   page: 13,
   name: "Checkbox Exempt Well", 
   isText: false,
   type: "checkbox",
   top: 563.771,
   left: 132.935,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Age Exempt Well", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 561.36,
   left: 154.56,
   width: 28.80,
   height: 181.44
}
,
{
   page: 13,
   name: "Checkbox ExemptWell Household", 
   isText: false,
   type: "checkbox",
   top: 559.767,
   left: 188.991,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Permit no Household use", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 571.8,
   left: 230.52,
   width: 355.56,
   height: 14.52
}
,
{
   page: 13,
   name: "Checkbox ExemptWell Domestic", 
   isText: false,
   type: "checkbox",
   top: 590.999,
   left: 188.991,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Permit no Domestic use", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 618.6,
   left: 230.52,
   width: 355.56,
   height: 14.52
}
,
{
   page: 13,
   name: "Checkbox ExemptWell Livestock", 
   isText: false,
   type: "checkbox",
   top: 638.247,
   left: 188.991,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Permit no Livestock", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 649.56,
   left: 230.52,
   width: 355.56,
   height: 14.52
}
,
{
   page: 13,
   name: "Checkbox ExemptWell Other", 
   isText: false,
   type: "checkbox",
   top: 669.478,
   left: 188.991,
   width: 13.680,
   height: 13.680
}
,
{
   page: 13,
   name: "Exempt Well Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 682.211,
   left: 188.629,
   width: 398.106,
   height: 40.9208
}
,
{
   page: 13,
   name: "Permit no Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 723.0583,
   left: 230.52,
   width: 355.56,
   height: 13.5017
}
,
{
   page: 14,
   name: "Checkbox TypeOfWell Small Capacity", 
   isText: false,
   type: "checkbox",
   top: 68.069,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age TypeOfWell Small Capacity", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 63.36,
   left: 154.56,
   width: 28.80,
   height: 122.64
}
,
{
   page: 14,
   name: "Checkbox TypeOfWell Small Capacity Domestic", 
   isText: false,
   type: "checkbox",
   top: 61.662,
   left: 188.991,
   width: 13.680,
   height: 13.680
}
,
{
   page: 14,
   name: "TypeOfWell Small Capacity Domestic Use Permit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 89.4,
   left: 229.44,
   width: 357.00,
   height: 14.76
}
,
{
   page: 14,
   name: "Checkbox TypeOfWell Small Capacity Other", 
   isText: false,
   type: "checkbox",
   top: 108.109,
   left: 188.991,
   width: 13.680,
   height: 13.680
}
,
{
   page: 14,
   name: "TypeOfWell Small Capacity Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 121.375,
   left: 187.974,
   width: 402.688,
   height: 42.905
}
,
{
   page: 14,
   name: "TypeOfWell Small Capacity Other Permit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 165,
   left: 230.52,
   width: 355.56,
   height: 14.76
}
,
{
   page: 14,
   name: "Checkbox Water Well metered", 
   isText: false,
   type: "checkbox",
   top: 190.593,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Well metered", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 187.68,
   left: 154.56,
   width: 28.80,
   height: 54.00
}
,
{
   page: 14,
   name: "Water Well metered", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 187.8,
   left: 186.12,
   width: 407.04,
   height: 53.88
}
,
{
   page: 14,
   name: "Checkbox Water Well Pump", 
   isText: false,
   type: "checkbox",
   top: 245.849,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Well Pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 243.183,
   left: 154.473,
   width: 30.218,
   height: 38.364
}
,
{
   page: 14,
   name: "Water Well Pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 243.48,
   left: 186.12,
   width: 407.04,
   height: 40.20
}
,
{
   page: 14,
   name: "Checkbox Water Brand name and pump number", 
   isText: false,
   type: "checkbox",
   top: 287.491,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Brand name and pump number", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 284.729,
   left: 154.473,
   width: 30.218,
   height: 39.018
}
,
{
   page: 14,
   name: "Water Brand name and pump number", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 285.48,
   left: 186.12,
   width: 407.04,
   height: 39.96
}
,
{
   page: 14,
   name: "Checkbox Water Well Pump Date installed", 
   isText: false,
   type: "checkbox",
   top: 328.333,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Well Pump Date installed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 325.965,
   left: 154.473,
   width: 30.218,
   height: 25.927
}
,
{
   page: 14,
   name: "Water Well Pump Date installed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 327,
   left: 185.88,
   width: 407.52,
   height: 26.52
}
,
{
   page: 14,
   name: "Checkbox Water Well Pump Date of last inspection", 
   isText: false,
   type: "checkbox",
   top: 360.365,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Well Pump Date of last inspection", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 353.456,
   left: 154.473,
   width: 30.218,
   height: 26.582
}
,
{
   page: 14,
   name: "Water Well Pump Date of last inspection", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 355.08,
   left: 185.88,
   width: 407.52,
   height: 26.52
}
,
{
   page: 14,
   name: "Checkbox Water Well Pump Date of last service", 
   isText: false,
   type: "checkbox",
   top: 385.991,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Well Pump Date of last service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 383.565,
   left: 154.473,
   width: 30.218,
   height: 38.364
}
,
{
   page: 14,
   name: "Water Well Pump Date of last service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 383.4,
   left: 186.12,
   width: 407.04,
   height: 40.2
}
,
{
   page: 14,
   name: "Checkbox Water Well Pump Depth", 
   isText: false,
   type: "checkbox",
   top: 428.434,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Well Pump Depth", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 424.802,
   left: 154.473,
   width: 30.218,
   height: 25.273
}
,
{
   page: 14,
   name: "Water Well Pump Depth", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 425.16,
   left: 185.88,
   width: 407.52,
   height: 26.52
}
,
{
   page: 14,
   name: "Checkbox Water Well Pump GPM and date last measured", 
   isText: false,
   type: "checkbox",
   top: 456.462,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Well Pump GPM and date last measured", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 454.257,
   left: 154.473,
   width: 30.218,
   height: 23.309
}
,
{
   page: 14,
   name: "Water Well Pump GPM and date last measured", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 453.24,
   left: 185.88,
   width: 407.52,
   height: 26.52
}
,
{
   page: 14,
   name: "Checkbox Water Galvanized pipe", 
   isText: false,
   type: "checkbox",
   top: 483.69,
   left: 132.736,
   width: 13.679,
   height: 13.68
}
,
{
   page: 14,
   name: "Age Water Galvanized pipe", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 482.402,
   left: 154.473,
   width: 30.218,
   height: 37.709
}
,
{
   page: 14,
   name: "Water Galvanized pipe", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 481.56,
   left: 186.12,
   width: 407.04,
   height: 40.20
}
,
{
   page: 14,
   name: "Checkbox Water Polybutylene pipe", 
   isText: false,
   type: "checkbox",
   top: 526.133,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Polybutylene pipe", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 524.293,
   left: 154.473,
   width: 30.218,
   height: 37.709
}
,
{
   page: 14,
   name: "Water Polybutylene pipe", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 523.56,
   left: 186.12,
   width: 407.04,
   height: 39.96
}
,
{
   page: 14,
   name: "Checkbox Water Cistern water storage", 
   isText: false,
   type: "checkbox",
   top: 567.775,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Cistern water storage", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 565.53,
   left: 154.473,
   width: 30.218,
   height: 23.963
}
,
{
   page: 14,
   name: "Water Cistern water storage", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 565.08,
   left: 185.88,
   width: 407.52,
   height: 26.52
}
,
{
   page: 14,
   name: "Checkbox Water Cistern water storage Number of gallons", 
   isText: false,
   type: "checkbox",
   top: 596.604,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Cistern water storage Number of gallons", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 593.33,
   left: 154.473,
   width: 30.218,
   height: 23.964
}
,
{
   page: 14,
   name: "Water Cistern water storage Number of gallons", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 593.16,
   left: 185.88,
   width: 407.52,
   height: 26.52
}
,
{
   page: 14,
   name: "Checkbox Water Supplemental water purchased", 
   isText: false,
   type: "checkbox",
   top: 623.031,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Supplemental water purchased", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 619.857,
   left: 154.473,
   width: 30.218,
   height: 40.328
}
,
{
   page: 14,
   name: "Water Supplemental water purchased", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 621.48,
   left: 186.12,
   width: 407.04,
   height: 40.20
}
,
{
   page: 14,
   name: "Checkbox Water Supplemental water purchased Name and contact information", 
   isText: false,
   type: "checkbox",
   top: 667.076,
   left: 132.736,
   width: 13.679,
   height: 13.680
}
,
{
   page: 14,
   name: "Age Water Supplemental water purchased Name and contact information", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 663.36,
   left: 154.473,
   width: 30.218,
   height: 59.76
}
,
{
   page: 14,
   name: "Water Supplemental water purchased Name and contact information", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 663.48,
   left: 186.12,
   width: 407.04,
   height: 59.64
}
,
{
   page: 14,
   name: "Water Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 724.68,
   left: 37.8,
   width: 87.12,
   height: 26.52
}
,
{
   page: 14,
   name: "Checkbox Water Extra Row", 
   isText: false,
   type: "checkbox",
   top: 727.1367,
   left: 132.736,
   width: 13.679,
   height: 13.6800
}
,
{
   page: 14,
   name: "Age Water Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 726.5486,
   left: 154.473,
   width: 30.218,
   height: 22.0000
}
,
{
   page: 14,
   name: "Water Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 724.68,
   left: 185.88,
   width: 407.52,
   height: 26.52
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Water heaters", 
   isText: false,
   type: "checkbox",
   top: 120.922,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Water heaters", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 115.8,
   left: 154.56,
   width: 33.24,
   height: 54.12
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Water heaters", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 115.8,
   left: 190.56,
   width: 402.60,
   height: 54.12
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Water filter system", 
   isText: false,
   type: "checkbox",
   top: 176.178,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Water filter system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 171.72,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Water filter system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 171.72,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Water softener", 
   isText: false,
   type: "checkbox",
   top: 232.235,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Water softener", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 227.4,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Water softener", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 227.4,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Water system pump", 
   isText: false,
   type: "checkbox",
   top: 287.491,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Water system pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 283.08,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Water system pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 283.08,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Sauna", 
   isText: false,
   type: "checkbox",
   top: 344.349,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Sauna", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 338.76,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Sauna", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 338.76,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Hot tub or spa", 
   isText: false,
   type: "checkbox",
   top: 400.406,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Hot tub or spa", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 394.44,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Hot tub or spa", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 394.44,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Steam roomshower", 
   isText: false,
   type: "checkbox",
   top: 454.06,
   left: 132.134,
   width: 13.680,
   height: 13.68
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Steam roomshower", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 450.12,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Steam roomshower", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 450.12,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Underground sprinkler system", 
   isText: false,
   type: "checkbox",
   top: 510.117,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Underground sprinkler system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 505.8,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Underground sprinkler system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 505.8,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Fire sprinkler system", 
   isText: false,
   type: "checkbox",
   top: 565.373,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Fire sprinkler system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 561.48,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Fire sprinkler system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 561.48,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Backflow prevention device", 
   isText: false,
   type: "checkbox",
   top: 622.23,
   left: 132.134,
   width: 13.680,
   height: 13.68
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Backflow prevention device", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 617.16,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Backflow prevention device", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 617.16,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Irrigation pump", 
   isText: false,
   type: "checkbox",
   top: 677.486,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Irrigation pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 672.84,
   left: 154.56,
   width: 33.24,
   height: 40.20
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Irrigation pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 672.84,
   left: 190.56,
   width: 402.60,
   height: 40.20
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 714.6,
   left: 37.68,
   width: 87.72,
   height: 26.52
}
,
{
   page: 15,
   name: "Checkbox WaterProblemsNowExisting Extra Row", 
   isText: false,
   type: "checkbox",
   top: 718.3278,
   left: 132.134,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 15,
   name: "Age WaterProblemsNowExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 714.6,
   left: 154.32,
   width: 33.72,
   height: 26.52
}
,
{
   page: 15,
   name: "WaterProblemsNowExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 714.6,
   left: 190.32,
   width: 403.08,
   height: 26.52
}
,
{
   page: 16,
   name: "Checkbox WaterProblemsEverExisting Leaks backups etc", 
   isText: false,
   type: "checkbox",
   top: 127.329,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Age WaterProblemsEverExisting Leaks backups etc", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 120.665,
   left: 154.56,
   width: 33.24,
   height: 95.640
}
,
{
   page: 16,
   name: "WaterProblemsEverExisting Leaks backups etc", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 121.32,
   left: 190.56,
   width: 402.60,
   height: 95.64
}
,
{
   page: 16,
   name: "Checkbox WaterProblemsEverExistingWell", 
   isText: false,
   type: "checkbox",
   top: 224.227,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Age WaterProblemsEverExistingWell", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.76,
   left: 154.56,
   width: 33.24,
   height: 67.80
}
,
{
   page: 16,
   name: "WaterProblemsEverExistingWell", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.76,
   left: 190.56,
   width: 402.60,
   height: 67.80
}
,
{
   page: 16,
   name: "Checkbox WaterProblemsEverExisting Pool", 
   isText: false,
   type: "checkbox",
   top: 293.898,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Age WaterProblemsEverExisting Pool", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 288.36,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 16,
   name: "WaterProblemsEverExisting Pool", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 288.36,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 16,
   name: "Checkbox WaterProblemsEverExisting Irrigation system", 
   isText: false,
   type: "checkbox",
   top: 349.154,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Age WaterProblemsEverExisting Irrigation system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 344.04,
   left: 154.56,
   width: 33.24,
   height: 67.56
}
,
{
   page: 16,
   name: "WaterProblemsEverExisting Irrigation system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 344.04,
   left: 190.56,
   width: 402.60,
   height: 67.56
}
,
{
   page: 16,
   name: "Checkbox WaterProblemsEverExisting Water has been tested for potability", 
   isText: false,
   type: "checkbox",
   top: 418.824,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Age WaterProblemsEverExisting Water has been tested for potability", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 413.4,
   left: 154.56,
   width: 33.24,
   height: 53.88
}
,
{
   page: 16,
   name: "WaterProblemsEverExisting Water has been tested for potability", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 413.4,
   left: 190.56,
   width: 402.60,
   height: 53.88
}
,
{
   page: 16,
   name: "Checkbox WaterProblemsEverExisting Water tested for potability results", 
   isText: false,
   type: "checkbox",
   top: 475.682,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Age WaterProblemsEverExisting Water tested for potability results", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 469.08,
   left: 154.56,
   width: 33.24,
   height: 83.64
}
,
{
   page: 16,
   name: "WaterProblemsEverExisting Water tested for potability results", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 469.08,
   left: 190.56,
   width: 402.60,
   height: 83.64
}
,
{
   page: 16,
   name: "WaterProblemsEverExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 554.28,
   left: 37.68,
   width: 87.72,
   height: 26.52
}
,
{
   page: 16,
   name: "Checkbox WaterProblemsEverExisting Extra Row", 
   isText: false,
   type: "checkbox",
   top: 557.365,
   left: 132.134,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Age WaterProblemsEverExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 554.28,
   left: 154.32,
   width: 33.72,
   height: 26.52
}
,
{
   page: 16,
   name: "WaterProblemsEverExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 554.28,
   left: 190.32,
   width: 403.08,
   height: 26.52
}
,
{
   page: 16,
   name: "Checkbox SOW Public", 
   isText: false,
   type: "checkbox",
   top: 616.588,
   left: 123.216,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Checkbox SOW Community", 
   isText: false,
   type: "checkbox",
   top: 616.588,
   left: 171.076,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Checkbox SOW Well", 
   isText: false,
   type: "checkbox",
   top: 616.079,
   left: 237.267,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Checkbox SOW Shared Well", 
   isText: false,
   type: "checkbox",
   top: 616.588,
   left: 279.017,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Checkbox SOW Other", 
   isText: false,
   type: "checkbox",
   top: 616.588,
   left: 349.79,
   width: 13.68,
   height: 13.680
}
,
{
   page: 16,
   name: "Checkbox SOW None", 
   isText: false,
   type: "checkbox",
   top: 616.588,
   left: 396.632,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Radiobutton WellPermitProvided Is", 
   isText: false,
   type: "checkbox",
   top: 634.408,
   left: 265.27,
   width: 14.335,
   height: 13.680
}
,
{
   page: 16,
   name: "Radiobutton WellPermitProvided Is Not", 
   isText: false,
   type: "checkbox",
   top: 634.408,
   left: 294.801,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "WaterRights Well Permit Number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 631.8,
   left: 433.8,
   width: 144.0,
   height: 12.84
}
,
{
   page: 16,
   name: "Radiobutton DrillingRecordsProvided Are", 
   isText: false,
   type: "checkbox",
   top: 648.155,
   left: 101.977,
   width: 13.025,
   height: 13.680
}
,
{
   page: 16,
   name: "Radiobutton DrillingRecordsProvided Are Not", 
   isText: false,
   type: "checkbox",
   top: 648.174,
   left: 135.435,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "Radiobutton SharedWellAgreement Yes", 
   isText: false,
   type: "checkbox",
   top: 648.665,
   left: 312.622,
   width: 13.680,
   height: 13.025
}
,
{
   page: 16,
   name: "Radiobutton SharedWellAgreement No", 
   isText: false,
   type: "checkbox",
   top: 649.174,
   left: 358.717,
   width: 13.680,
   height: 13.680
}
,
{
   page: 16,
   name: "SOURCE OF WATER WATER SUPPLY", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 665.738,
   left: 41.3227,
   width: 539.1063,
   height: 12.219
}
,
{
   page: 16,
   name: "SOW Water Provider Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 694.88,
   left: 67.2,
   width: 240.12,
   height: 14.1491
}
,
{
   page: 16,
   name: "SOW Water Provider Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 695.88,
   left: 345.6,
   width: 234.0,
   height: 14.1491
}
,
{
   page: 16,
   name: "SOW Water Provider Web Site", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 716.76,
   left: 78.96,
   width: 307.20,
   height: 14.1491
}
,
{
   page: 16,
   name: "SOW Water Provider Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 716.76,
   left: 432.96,
   width: 148.56,
   height: 14.1491
}
,
{
   page: 17,
   name: "Checkbox There is no well or water provider for the property", 
   isText: false,
   type: "checkbox",
   top: 47.128,
   left: 39.2729,
   width: 13.6800,
   height: 13.679
}
,
{
   page: 17,
   name: "SOW Source", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 60.08,
   left: 37.1684,
   width: 555.7976,
   height: 60.696
}
,
{
   page: 17,
   name: "Checkbox Sewer Public sanitary sewer service", 
   isText: false,
   type: "checkbox",
   top: 250.037,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 17,
   name: "Sewer Public sanitary sewer service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 246.84,
   left: 168,
   width: 425.16,
   height: 53.88
}
,
{
   page: 17,
   name: "Checkbox Sewer Public Name and contact information", 
   isText: false,
   type: "checkbox",
   top: 306.329,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 17,
   name: "Sewer Public Name and contact information", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 302.52,
   left: 168,
   width: 425.16,
   height: 53.88
}
,
{
   page: 17,
   name: "Checkbox Sewer Public Date the sewer line was last scoped", 
   isText: false,
   type: "checkbox",
   top: 361.311,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 17,
   name: "Sewer Public Date the sewer line was last scoped", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 358.2,
   left: 168,
   width: 425.16,
   height: 40.2
}
,
{
   page: 17,
   name: "Checkbox Sewer CommunitySanitarySewerService Information", 
   isText: false,
   type: "checkbox",
   top: 401.893,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 17,
   name: "Sewer CommunitySanitarySewerService Information", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 400.2,
   left: 168,
   width: 425.16,
   height: 39.96
}
,
{
   page: 17,
   name: "Checkbox Sewer CommunitySanitarySewerService Name and contact information", 
   isText: false,
   type: "checkbox",
   top: 445.093,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 17,
   name: "Sewer CommunitySanitarySewerService Name and contact information", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 441.96,
   left: 168,
   width: 425.16,
   height: 47.64
}
,
{
   page: 17,
   name: "Checkbox Sewer ComunitySanitarySewerService Date the sewer line was last scoped", 
   isText: false,
   type: "checkbox",
   top: 494.184,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 17,
   name: "Sewer ComunitySanitarySewerService Date the sewer line was last scoped", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 491.4,
   left: 168,
   width: 425.16,
   height: 44.76
}
,
{
   page: 17,
   name: "Checkbox Sewer Septic", 
   isText: false,
   type: "checkbox",
   top: 541.311,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 17,
   name: "Sewer SepticSystem Information", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 537.96,
   left: 168,
   width: 425.16,
   height: 53.88
}
,
{
   page: 17,
   name: "Checkbox SepticSystem Type", 
   isText: false,
   type: "checkbox",
   top: 596.948,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 17,
   name: "Checkbox SepticSystemType Tank", 
   isText: false,
   type: "checkbox",
   top: 593.675,
   left: 170.837,
   width: 13.680,
   height: 13.680
}
,
{
   page: 17,
   name: "Checkbox SepticSystemType Leach", 
   isText: false,
   type: "checkbox",
   top: 593.021,
   left: 210.11,
   width: 13.68,
   height: 13.680
}
,
{
   page: 17,
   name: "Checkbox SepticSystemType Lagoon", 
   isText: false,
   type: "checkbox",
   top: 593.021,
   left: 251.347,
   width: 13.680,
   height: 13.680
}
,
{
   page: 17,
   name: "Sewer SepticSystem Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 607.874,
   left: 168.0,
   width: 425.16,
   height: 42.046
}
,
{
   page: 17,
   name: "Checkbox Sewer SepticSystem Date of issuance", 
   isText: false,
   type: "checkbox",
   top: 655.203,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 17,
   name: "Sewer SepticSystem Date of issuance", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 652.92,
   left: 168,
   width: 425.16,
   height: 35.64
}
,
{
   page: 17,
   name: "Checkbox Sewer SepticSystem Date of latest inspection", 
   isText: false,
   type: "checkbox",
   top: 692.5121,
   left: 145.31,
   width: 13.68,
   height: 13.6800
}
,
{
   page: 17,
   name: "Sewer SepticSystem Date of latest inspection", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 690.12,
   left: 167.76,
   width: 425.64,
   height: 26.52
}
,
{
   page: 17,
   name: "Checkbox Sewer SepticSystem Date of latest pumping", 
   isText: false,
   type: "checkbox",
   top: 721.3123,
   left: 145.31,
   width: 13.68,
   height: 13.6799
}
,
{
   page: 17,
   name: "Sewer SepticSystem Date of latest pumping", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 718.2,
   left: 167.76,
   width: 425.64,
   height: 26.52
}
,
{
   page: 18,
   name: "Checkbox Sewer SepticSystem Maintenance agreementX", 
   isText: false,
   type: "checkbox",
   top: 49.746,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 18,
   name: "Checkbox Sewer SepticSystem Maintenance agreement Mandated", 
   isText: false,
   type: "checkbox",
   top: 47.128,
   left: 170.183,
   width: 13.680,
   height: 14.334
}
,
{
   page: 18,
   name: "Sewer SepticSystem Maintenance agreement", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 67.12,
   left: 168.0,
   width: 425.16,
   height: 19.08
}
,
{
   page: 18,
   name: "Checkbox Sewer SepticSystem Mainenance agreement is not mandated", 
   isText: false,
   type: "checkbox",
   top: 83.782,
   left: 170.837,
   width: 13.680,
   height: 13.680
}
,
{
   page: 18,
   name: "Sewer SepticSystem Mainenance agreement is not mandated", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 95.88,
   left: 168,
   width: 425.16,
   height: 40.68
}
,
{
   page: 18,
   name: "Checkbox Other sanitary sewer service", 
   isText: false,
   type: "checkbox",
   top: 140.728,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 18,
   name: "Other sanitary sewer service", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 149.2,
   left: 168.0,
   width: 425.16,
   height: 33.0
}
,
{
   page: 18,
   name: "Checkbox Gray water storageuse", 
   isText: false,
   type: "checkbox",
   top: 187.855,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 18,
   name: "Gray water storageuse", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 184.68,
   left: 168,
   width: 425.16,
   height: 40.20
}
,
{
   page: 18,
   name: "Sewer Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 226.44,
   left: 33.12,
   width: 105.24,
   height: 26.52
}
,
{
   page: 18,
   name: "Checkbox Sewer Extra Row", 
   isText: false,
   type: "checkbox",
   top: 229.746,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 18,
   name: "Sewer Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 226.44,
   left: 167.76,
   width: 425.64,
   height: 26.52
}
,
{
   page: 18,
   name: "Checkbox SewerEverExisting Leaks backups", 
   isText: false,
   type: "checkbox",
   top: 331.201,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 18,
   name: "SewerEverExisting Leaks backups", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 328.2,
   left: 168,
   width: 425.16,
   height: 81.48
}
,
{
   page: 18,
   name: "Checkbox SewerEverExisting Lift station sewage ejector pump", 
   isText: false,
   type: "checkbox",
   top: 414.329,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 18,
   name: "Lift station sewage ejector pump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 411.48,
   left: 168,
   width: 425.16,
   height: 53.88
}
,
{
   page: 18,
   name: "SewerEverExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 466.92,
   left: 33.12,
   width: 105.24,
   height: 26.52
}
,
{
   page: 18,
   name: "Checkbox SewerEverExisting Extra Row Title", 
   isText: false,
   type: "checkbox",
   top: 469.311,
   left: 145.31,
   width: 13.68,
   height: 13.680
}
,
{
   page: 18,
   name: "SewerEverExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 466.92,
   left: 167.76,
   width: 425.64,
   height: 26.52
}
,
{
   page: 18,
   name: "Checkbox Flooding Issues", 
   isText: false,
   type: "checkbox",
   top: 589.748,
   left: 141.382,
   width: 13.680,
   height: 13.680
}
,
{
   page: 18,
   name: "Flooding Issues", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 586.44,
   left: 163.44,
   width: 429.72,
   height: 81.48
}
,
{
   page: 18,
   name: "Checkbox Drainage Issues", 
   isText: false,
   type: "checkbox",
   top: 674.839,
   left: 141.382,
   width: 13.680,
   height: 13.680
}
,
{
   page: 18,
   name: "Drainage Issues", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 669.72,
   left: 163.44,
   width: 429.72,
   height: 79.80
}
,
{
   page: 19,
   name: "Checkbox FloodingEverExisting", 
   isText: false,
   type: "checkbox",
   top: 51.055,
   left: 141.382,
   width: 13.680,
   height: 13.680
}
,
{
   page: 19,
   name: "FloodingEverExisting Grading", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.52,
   left: 163.68,
   width: 430.18,
   height: 67.92
}
,
{
   page: 19,
   name: "Checkbox Water intrusion in the basement crawl space or other parts of Property", 
   isText: false,
   type: "checkbox",
   top: 120.437,
   left: 141.382,
   width: 13.680,
   height: 13.680
}
,
{
   page: 19,
   name: "Water intrusion in the basement crawl space or other parts of Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 116.88,
   left: 163.68,
   width: 430.18,
   height: 79.876
}
,
{
   page: 19,
   name: "Checkbox Repairs made to control water intrusion in the basement crawl space or other parts of the Property", 
   isText: false,
   type: "checkbox",
   top: 204.219,
   left: 141.382,
   width: 13.680,
   height: 13.680
}
,
{
   page: 19,
   name: "Repairs made to control water intrusion in the basement crawl space or other parts of the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 200.16,
   left: 163.68,
   width: 430.18,
   height: 66.196
}
,
{
   page: 19,
   name: "FloodingEverExisting Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 269.88,
   left: 33.12,
   width: 101.40,
   height: 26.52
}
,
{
   page: 19,
   name: "Checkbox FloodingEverExisting Extra Row", 
   isText: false,
   type: "checkbox",
   top: 273.601,
   left: 141.382,
   width: 13.680,
   height: 13.680
}
,
{
   page: 19,
   name: "FloodingEverExisting Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 270.338,
   left: 163.68,
   width: 430.18,
   height: 25.473
}
,
{
   page: 19,
   name: "Checkbox Drainage or retention ponds dams storm water detention basins or other similar facilities8", 
   isText: false,
   type: "checkbox",
   top: 375.711,
   left: 141.382,
   width: 13.680,
   height: 13.680
}
,
{
   page: 19,
   name: "Drainage or retention ponds dams storm water detention basins or other similar facilities", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 371.52,
   left: 159.36,
   width: 433.80,
   height: 88.80
}
,
{
   page: 19,
   name: "Drainage Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 462.491,
   left: 33.12,
   width: 101.40,
   height: 31.549
}
,
{
   page: 19,
   name: "Checkbox Drainage Extra Row", 
   isText: false,
   type: "checkbox",
   top: 464.075,
   left: 141.382,
   width: 13.680,
   height: 13.680
}
,
{
   page: 19,
   name: "Drainage Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 461.836,
   left: 159.12,
   width: 434.28,
   height: 32.204
}
,
{
   page: 19,
   name: "Checkbox Included fixtures and equipment", 
   isText: false,
   type: "checkbox",
   top: 588.439,
   left: 144.655,
   width: 13.680,
   height: 13.680
}
,
{
   page: 19,
   name: "Included fixtures and equipment", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 585.24,
   left: 168,
   width: 425.16,
   height: 81.48
}
,
{
   page: 19,
   name: "Checkbox Stains on carpet", 
   isText: false,
   type: "checkbox",
   top: 672.221,
   left: 144.655,
   width: 13.680,
   height: 13.680
}
,
{
   page: 19,
   name: "Stains on carpet", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 668.52,
   left: 168.655,
   width: 425.160,
   height: 81.48
}
,
{
   page: 20,
   name: "Checkbox Floors", 
   isText: false,
   type: "checkbox",
   top: 52.854,
   left: 145.748,
   width: 13.680,
   height: 13.680
}
,
{
   page: 20,
   name: "Floors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.52,
   left: 168.011,
   width: 424.355,
   height: 67.92
}
,
{
   page: 20,
   name: "Disclosure Improvements Now Existing Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 117,
   left: 33.12,
   width: 105.24,
   height: 26.52
}
,
{
   page: 20,
   name: "Checkbox Disclosure Improvements Now Existing Extra Row", 
   isText: false,
   type: "checkbox",
   top: 120.122,
   left: 145.748,
   width: 13.680,
   height: 13.680
}
,
{
   page: 20,
   name: "Disclosure Improvements Now Existing Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 117.699,
   left: 168.011,
   width: 424.355,
   height: 24.578
}
,
{
   page: 20,
   name: "Checkbox Zoning violation or variance", 
   isText: false,
   type: "checkbox",
   top: 267.471,
   left: 145.748,
   width: 13.680,
   height: 13.680
}
,
{
   page: 20,
   name: "Zoning violation or variance", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 261.48,
   left: 168,
   width: 425.16,
   height: 95.16
}
,
{
   page: 20,
   name: "Checkbox Notice or threat of condemnation proceedings", 
   isText: false,
   type: "checkbox",
   top: 362.768,
   left: 145.748,
   width: 13.680,
   height: 13.680
}
,
{
   page: 20,
   name: "Notice or threat of condemnation proceedings", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 358.44,
   left: 168,
   width: 425.16,
   height: 95.40
}
,
{
   page: 20,
   name: "Checkbox Notice of any adverse conditions from any government", 
   isText: false,
   type: "checkbox",
   top: 461.267,
   left: 145.748,
   width: 13.680,
   height: 13.680
}
,
{
   page: 20,
   name: "Notice of any adverse conditions from any government", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 455.64,
   left: 168,
   width: 425.16,
   height: 95.40
}
,
{
   page: 20,
   name: "Checkbox Notice of zoning action", 
   isText: false,
   type: "checkbox",
   top: 556.564,
   left: 145.748,
   width: 13.680,
   height: 13.680
}
,
{
   page: 20,
   name: "Notice of zoning action", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 552.84,
   left: 168,
   width: 425.16,
   height: 95.16
}
,
{
   page: 20,
   name: "Building code city or county violations", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 649.8,
   left: 168,
   width: 425.16,
   height: 95.4
}
,
{
   page: 20,
   name: "Checkbox Building code city or county violations", 
   isText: false,
   type: "checkbox",
   top: 654.263,
   left: 145.748,
   width: 13.680,
   height: 13.680
}
,
{
   page: 21,
   name: "Checkbox Violation of restrictive covenants or owners association rules or regulations", 
   isText: false,
   type: "checkbox",
   top: 69.671,
   left: 144.947,
   width: 13.680,
   height: 13.680
}
,
{
   page: 21,
   name: "Violation of restrictive covenants or owners association rules or regulations", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 65.64,
   left: 168,
   width: 425.16,
   height: 81.48
}
,
{
   page: 21,
   name: "Checkbox Any building or improvements constructed", 
   isText: false,
   type: "checkbox",
   top: 152.154,
   left: 144.947,
   width: 13.680,
   height: 13.680
}
,
{
   page: 21,
   name: "Any building or improvements constructed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 148.92,
   left: 168,
   width: 425.16,
   height: 99.24
}
,
{
   page: 21,
   name: "Checkbox Any additions or alterations made with a Building Permit", 
   isText: false,
   type: "checkbox",
   top: 253.056,
   left: 144.947,
   width: 13.680,
   height: 13.680
}
,
{
   page: 21,
   name: "Any additions or alterations made with a Building Permit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 249.96,
   left: 168,
   width: 425.16,
   height: 81.48
}
,
{
   page: 21,
   name: "Checkbox Any additions or non aesthetic alterations made without a Building Permit", 
   isText: false,
   type: "checkbox",
   top: 336.341,
   left: 144.947,
   width: 13.680,
   height: 13.680
}
,
{
   page: 21,
   name: "Any additions or non aesthetic alterations made without a Building Permit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 333.24,
   left: 168,
   width: 425.16,
   height: 81.48
}
,
{
   page: 21,
   name: "Checkbox Other legal action", 
   isText: false,
   type: "checkbox",
   top: 421.227,
   left: 144.947,
   width: 13.680,
   height: 13.680
}
,
{
   page: 21,
   name: "Other legal action", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 416.52,
   left: 168,
   width: 425.16,
   height: 81.48
}
,
{
   page: 21,
   name: "Checkbox Any part of the Property leased to others", 
   isText: false,
   type: "checkbox",
   top: 504.511,
   left: 144.947,
   width: 13.680,
   height: 13.680
}
,
{
   page: 21,
   name: "Any part of the Property leased to others", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 499.8,
   left: 168,
   width: 425.16,
   height: 81.48
}
,
{
   page: 21,
   name: "Checkbox Used for shortterm rentals in the past year", 
   isText: false,
   type: "checkbox",
   top: 587.796,
   left: 144.947,
   width: 13.680,
   height: 13.680
}
,
{
   page: 21,
   name: "Used for shortterm rentals in the past year", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 583.08,
   left: 168,
   width: 425.16,
   height: 81.48
}
,
{
   page: 21,
   name: "Checkbox Grandfathered conditions or uses", 
   isText: false,
   type: "checkbox",
   top: 669.478,
   left: 144.947,
   width: 13.680,
   height: 13.680
}
,
{
   page: 21,
   name: "Grandfathered conditions or uses", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 666.36,
   left: 168,
   width: 425.16,
   height: 53.88
}
,
{
   page: 21,
   name: "Zoning Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 721.8,
   left: 33.12,
   width: 105.72,
   height: 26.76
}
,
{
   page: 21,
   name: "Checkbox Zoning Extra Row", 
   isText: false,
   type: "checkbox",
   top: 723.9335,
   left: 144.947,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 21,
   name: "Zoning Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 721.8,
   left: 167.76,
   width: 425.64,
   height: 26.76
}
,
{
   page: 22,
   name: "Checkbox Any access problems issues or concerns", 
   isText: false,
   type: "checkbox",
   top: 115.317,
   left: 139.341,
   width: 13.680,
   height: 13.680
}
,
{
   page: 22,
   name: "Any access problems issues or concerns", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 109.56,
   left: 159.36,
   width: 433.32,
   height: 81.48
}
,
{
   page: 22,
   name: "Checkbox Roads trails paths or driveways through the Property used by others", 
   isText: false,
   type: "checkbox",
   top: 196.199,
   left: 139.341,
   width: 13.680,
   height: 13.680
}
,
{
   page: 22,
   name: "Roads trails paths or driveways through the Property used by others", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 192.84,
   left: 159.36,
   width: 433.32,
   height: 67.80
}
,
{
   page: 22,
   name: "Checkbox Public highway or county road bordering the Property", 
   isText: false,
   type: "checkbox",
   top: 265.869,
   left: 139.341,
   width: 13.680,
   height: 13.680
}
,
{
   page: 22,
   name: "Public highway or county road bordering the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 262.44,
   left: 159.36,
   width: 433.32,
   height: 81.48
}
,
{
   page: 22,
   name: "Checkbox Any proposed or existing transportation project that affects or is expected to affect the Property", 
   isText: false,
   type: "checkbox",
   top: 349.955,
   left: 139.341,
   width: 13.680,
   height: 13.680
}
,
{
   page: 22,
   name: "Any proposed or existing transportation project that affects or is expected to affect the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 345.72,
   left: 159.36,
   width: 433.32,
   height: 67.56
}
,
{
   page: 22,
   name: "Checkbox Encroachments boundary disputes or unrecorded easements", 
   isText: false,
   type: "checkbox",
   top: 418.023,
   left: 139.341,
   width: 13.680,
   height: 13.680
}
,
{
   page: 22,
   name: "Encroachments boundary disputes or unrecorded easements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 415.08,
   left: 159.36,
   width: 433.32,
   height: 67.80
}
,
{
   page: 22,
   name: "Checkbox Shared or common areas with adjoining properties", 
   isText: false,
   type: "checkbox",
   top: 488.495,
   left: 139.341,
   width: 13.680,
   height: 13.680
}
,
{
   page: 22,
   name: "Shared or common areas with adjoining properties", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 484.68,
   left: 159.36,
   width: 433.32,
   height: 81.48
}
,
{
   page: 22,
   name: "Checkbox Requirements for curb gravelpaving or landscaping", 
   isText: false,
   type: "checkbox",
   top: 570.978,
   left: 139.341,
   width: 13.680,
   height: 13.680
}
,
{
   page: 22,
   name: "Requirements for curb gravelpaving or landscaping", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 567.96,
   left: 159.36,
   width: 433.32,
   height: 67.56
}
,
{
   page: 22,
   name: "Checkbox Any limitations on parking or access", 
   isText: false,
   type: "checkbox",
   top: 639.848,
   left: 139.341,
   width: 13.680,
   height: 13.680
}
,
{
   page: 22,
   name: "Any limitations on parking or access", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 637.32,
   left: 159.36,
   width: 433.32,
   height: 67.80
}
,
{
   page: 22,
   name: "Access Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 706.92,
   left: 33.36,
   width: 100.92,
   height: 40.20
}
,
{
   page: 22,
   name: "Checkbox Access Extra Row", 
   isText: false,
   type: "checkbox",
   top: 711.9213,
   left: 139.341,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 22,
   name: "Access Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 706.92,
   left: 159.36,
   width: 433.32,
   height: 40.20
}
,
{
   page: 23,
   name: "Checkbox Hazardous materials on the Property", 
   isText: false,
   type: "checkbox",
   top: 138.54,
   left: 148.15,
   width: 13.68,
   height: 13.68
}
,
{
   page: 23,
   name: "Hazardous materials on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 134.04,
   left: 168.48,
   width: 424.68,
   height: 88.20
}
,
{
   page: 23,
   name: "Checkbox Underground storage tanks", 
   isText: false,
   type: "checkbox",
   top: 227.43,
   left: 148.15,
   width: 13.68,
   height: 13.68
}
,
{
   page: 23,
   name: "Underground storage tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 224.04,
   left: 168.48,
   width: 424.68,
   height: 40.20
}
,
{
   page: 23,
   name: "Checkbox Aboveground storage tanks", 
   isText: false,
   type: "checkbox",
   top: 269.873,
   left: 148.15,
   width: 13.68,
   height: 13.680
}
,
{
   page: 23,
   name: "Aboveground storage tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 266.04,
   left: 168.48,
   width: 424.68,
   height: 39.96
}
,
{
   page: 23,
   name: "Checkbox Underground transmission lines", 
   isText: false,
   type: "checkbox",
   top: 312.316,
   left: 148.15,
   width: 13.68,
   height: 13.680
}
,
{
   page: 23,
   name: "Underground transmission lines", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 307.8,
   left: 168.48,
   width: 424.68,
   height: 40.2
}
,
{
   page: 23,
   name: "Checkbox Property used as situated on or adjoining a dump", 
   isText: false,
   type: "checkbox",
   top: 353.959,
   left: 148.15,
   width: 13.68,
   height: 13.680
}
,
{
   page: 23,
   name: "Property used as situated on or adjoining a dump", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 349.8,
   left: 168.48,
   width: 424.68,
   height: 43.8
}
,
{
   page: 23,
   name: "Checkbox Monitoring wells or test equipment", 
   isText: false,
   type: "checkbox",
   top: 399.605,
   left: 148.15,
   width: 13.68,
   height: 13.680
}
,
{
   page: 23,
   name: "Monitoring wells or test equipment", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 395.4,
   left: 168.48,
   width: 424.68,
   height: 40.2
}
,
{
   page: 23,
   name: "Checkbox Sliding settling upheaval movement or instability of earth or expansive soils on the Property", 
   isText: false,
   type: "checkbox",
   top: 441.247,
   left: 148.15,
   width: 13.68,
   height: 13.680
}
,
{
   page: 23,
   name: "Sliding settling upheaval movement or instability of earth or expansive soils on the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 437.4,
   left: 168.48,
   width: 424.68,
   height: 67.8
}
,
{
   page: 23,
   name: "Checkbox Mine shafts tunnels or abandoned wells", 
   isText: false,
   type: "checkbox",
   top: 511.718,
   left: 148.15,
   width: 13.68,
   height: 13.680
}
,
{
   page: 23,
   name: "Mine shafts tunnels or abandoned wells", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 507,
   left: 168.48,
   width: 424.68,
   height: 39.96
}
,
{
   page: 23,
   name: "Checkbox Within a governmentally designated geological hazard or sensitive area", 
   isText: false,
   type: "checkbox",
   top: 552.56,
   left: 148.15,
   width: 13.68,
   height: 13.68
}
,
{
   page: 23,
   name: "Within a governmentally designated geological hazard or sensitive area", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 548.76,
   left: 168.48,
   width: 424.68,
   height: 40.20
}
,
{
   page: 23,
   name: "Checkbox Within a governmentally designated floodplain or wetland area", 
   isText: false,
   type: "checkbox",
   top: 594.202,
   left: 148.15,
   width: 13.68,
   height: 13.680
}
,
{
   page: 23,
   name: "Within a governmentally designated floodplain or wetland area", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 590.76,
   left: 168.48,
   width: 424.68,
   height: 39.96
}
,
{
   page: 23,
   name: "Checkbox Dead diseased or infested trees or shrubs", 
   isText: false,
   type: "checkbox",
   top: 635.043,
   left: 148.15,
   width: 13.68,
   height: 13.680
}
,
{
   page: 23,
   name: "Dead diseased or infested trees or shrubs", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 632.52,
   left: 168.48,
   width: 424.68,
   height: 40.20
}
,
{
   page: 23,
   name: "Checkbox Environmental assessments studies or reports done", 
   isText: false,
   type: "checkbox",
   top: 679.889,
   left: 148.15,
   width: 13.68,
   height: 13.6798
}
,
{
   page: 23,
   name: "Environmental assessments studies or reports done", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 674.52,
   left: 168.48,
   width: 424.68,
   height: 67.56
}
,
{
   page: 24,
   name: "Checkbox Used for any mining graveling or other natural resource extraction operations such as oil and gas wells", 
   isText: false,
   type: "checkbox",
   top: 52.854,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 24,
   name: "Used for any mining graveling or other natural resource extraction operations such as oil and gas wells", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.4,
   left: 169.004,
   width: 424.616,
   height: 55.8
}
,
{
   page: 24,
   name: "Checkbox Smoking inside improvements", 
   isText: false,
   type: "checkbox",
   top: 108.91,
   left: 148.951,
   width: 13.680,
   height: 13.68
}
,
{
   page: 24,
   name: "Smoking inside improvements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 104.52,
   left: 169.004,
   width: 424.616,
   height: 68.04
}
,
{
   page: 24,
   name: "Checkbox Animals kept in the residence", 
   isText: false,
   type: "checkbox",
   top: 178.581,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 24,
   name: "Animals kept in the residence", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 173.88,
   left: 169.004,
   width: 424.616,
   height: 68.28
}
,
{
   page: 24,
   name: "Checkbox Other environmental problems issues or concerns", 
   isText: false,
   type: "checkbox",
   top: 247.451,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 24,
   name: "Other environmental problems issues or concerns", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 243.48,
   left: 169.004,
   width: 424.616,
   height: 54.36
}
,
{
   page: 24,
   name: "Checkbox Odors", 
   isText: false,
   type: "checkbox",
   top: 303.507,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 24,
   name: "Odors", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 299.16,
   left: 169.004,
   width: 424.616,
   height: 54.36
}
,
{
   page: 24,
   name: "Environmental Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 355.08,
   left: 33.12,
   width: 110.28,
   height: 26.52
}
,
{
   page: 24,
   name: "Checkbox Environmental Extra Row", 
   isText: false,
   type: "checkbox",
   top: 357.162,
   left: 148.951,
   width: 13.680,
   height: 13.680
}
,
{
   page: 24,
   name: "Environmental Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 355.058,
   left: 169.004,
   width: 424.616,
   height: 24.644
}
,
{
   page: 24,
   name: "Checkbox Radon tests conducted", 
   isText: false,
   type: "checkbox",
   top: 457.263,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 24,
   name: "Radon tests conducted", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 451.8,
   left: 163.92,
   width: 429.24,
   height: 95.16
}
,
{
   page: 24,
   name: "Checkbox Radon concentrations detected or mitigation or remediation performed", 
   isText: false,
   type: "checkbox",
   top: 551.759,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 24,
   name: "Radon concentrations detected or mitigation or remediation performed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 548.76,
   left: 163.92,
   width: 429.24,
   height: 95.40
}
,
{
   page: 24,
   name: "Checkbox Radon mitigation system installed", 
   isText: false,
   type: "checkbox",
   top: 650.259,
   left: 143.544,
   width: 13.680,
   height: 13.680
}
,
{
   page: 24,
   name: "Radon mitigation system installed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 645.96,
   left: 163.92,
   width: 429.24,
   height: 67.56
}
,
{
   page: 24,
   name: "Radon Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 715.08,
   left: 33.12,
   width: 105.72,
   height: 26.52
}
,
{
   page: 24,
   name: "Checkbox Radon Extra Row", 
   isText: false,
   type: "checkbox",
   top: 716.7261,
   left: 143.544,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 24,
   name: "Radon Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 715.08,
   left: 163.68,
   width: 429.72,
   height: 26.52
}
,
{
   page: 25,
   name: "Checkbox Property is part of an owners association", 
   isText: false,
   type: "checkbox",
   top: 124.927,
   left: 175.179,
   width: 13.680,
   height: 13.680
}
,
{
   page: 25,
   name: "Property is part of an owners association", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 121.44,
   left: 194.52,
   width: 399.00,
   height: 22.32
}
,
{
   page: 25,
   name: "Checkbox Special assessments", 
   isText: false,
   type: "checkbox",
   top: 149.752,
   left: 175.179,
   width: 13.680,
   height: 13.680
}
,
{
   page: 25,
   name: "Special assessments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 145.56,
   left: 194.88,
   width: 398.28,
   height: 81.48
}
,
{
   page: 25,
   name: "Checkbox Problems or defects in the common elements", 
   isText: false,
   type: "checkbox",
   top: 233.036,
   left: 175.179,
   width: 13.680,
   height: 13.680
}
,
{
   page: 25,
   name: "Problems or defects in the common elements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 228.84,
   left: 194.88,
   width: 398.28,
   height: 67.80
}
,
{
   page: 25,
   name: "Checkbox Has the Association made demand or commenced a lawsuit against a builder or contractor alleging defective construction of improvements of the Association Property common area or property owned or controlled by the Association but outside the Sellers Property or unit", 
   isText: false,
   type: "checkbox",
   top: 374.78,
   left: 175.179,
   width: 13.680,
   height: 13.68
}
,
{
   page: 25,
   name: "Has the Association made demand or commenced a lawsuit against a builder or contractor alleging defective construction of improvements of the Association Property common area or property owned or controlled by the Association but outside the Sellers Property or unit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 370.2,
   left: 194.88,
   width: 398.28,
   height: 107.88
}
,
{
   page: 25,
   name: "HOA Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 479.64,
   left: 36.24,
   width: 134.28,
   height: 26.52
}
,
{
   page: 25,
   name: "Checkbox HOA Extra Row", 
   isText: false,
   type: "checkbox",
   top: 482.889,
   left: 175.179,
   width: 13.680,
   height: 13.680
}
,
{
   page: 25,
   name: "HOA Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 479.64,
   left: 194.64,
   width: 398.76,
   height: 26.52
}
,
{
   page: 25,
   name: "Checkbox OwnersAssociation Contact Information 1", 
   isText: false,
   type: "checkbox",
   top: 590.999,
   left: 175.179,
   width: 13.680,
   height: 13.680
}
,
{
   page: 25,
   name: "OwnersAssociation Contact Information 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 586.68,
   left: 194.88,
   width: 398.28,
   height: 53.88
}
,
{
   page: 25,
   name: "Checkbox OwnersAssociation Contact Information 2", 
   isText: false,
   type: "checkbox",
   top: 645.454,
   left: 175.179,
   width: 13.680,
   height: 13.680
}
,
{
   page: 25,
   name: "OwnersAssociation Contact Information 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 642.36,
   left: 194.88,
   width: 398.28,
   height: 47.16
}
,
{
   page: 25,
   name: "Checkbox OwnersAssociation Contact Information 3", 
   isText: false,
   type: "checkbox",
   top: 694.3034,
   left: 175.179,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 25,
   name: "OwnersAssociation Contact Information 3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 691.08,
   left: 194.64,
   width: 398.76,
   height: 26.52
}
,
{
   page: 25,
   name: "Checkbox OwnersAssociation Contact Information 4", 
   isText: false,
   type: "checkbox",
   top: 722.3318,
   left: 175.179,
   width: 13.680,
   height: 13.6800
}
,
{
   page: 25,
   name: "OwnersAssociation Contact Information 4", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 719.16,
   left: 194.64,
   width: 398.76,
   height: 26.52
}
,
{
   page: 26,
   name: "Checkbox MetroDistrict Information", 
   isText: false,
   type: "checkbox",
   top: 125.727,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 26,
   name: "MetroDistrict Information", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 121.08,
   left: 163.92,
   width: 429.24,
   height: 54.84
}
,
{
   page: 26,
   name: "Checkbox MetroDistrict Name of Metropolitan District 1", 
   isText: false,
   type: "checkbox",
   top: 205.008,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 26,
   name: "MetroDistrict Name of Metropolitan District 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 200.76,
   left: 163.92,
   width: 429.24,
   height: 40.20
}
,
{
   page: 26,
   name: "Checkbox MetroDistrict Official website of the Metropolitan District 1", 
   isText: false,
   type: "checkbox",
   top: 245.849,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 26,
   name: "MetroDistrict Official website of the Metropolitan District 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 242.76,
   left: 163.92,
   width: 429.24,
   height: 40.20
}
,
{
   page: 26,
   name: "Checkbox MetroDistrict Name of Metropolitan District 2", 
   isText: false,
   type: "checkbox",
   top: 287.491,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 26,
   name: "MetroDistrict Name of Metropolitan District 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 284.52,
   left: 163.68,
   width: 429.72,
   height: 26.52
}
,
{
   page: 26,
   name: "Checkbox MetroDistrict Official website of Metropolitan District 2", 
   isText: false,
   type: "checkbox",
   top: 314.719,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 26,
   name: "MetroDistrict Official website of Metropolitan District 2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 312.6,
   left: 163.68,
   width: 429.72,
   height: 26.52
}
,
{
   page: 26,
   name: "Checkbox Written reports of any building site roofing soils water sewer mold or engineering investigations or studies of the Property Provide copies of all such reports in possession of Seller", 
   isText: false,
   type: "checkbox",
   top: 420.426,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 26,
   name: "Written reports of any building site roofing soils water sewer mold or engineering investigations or studies of the Property Provide copies of all such reports in possession of Seller", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 416.28,
   left: 163.92,
   width: 429.24,
   height: 88.20
}
,
{
   page: 26,
   name: "Checkbox Any property insurance claim submitted whether paid or not", 
   isText: false,
   type: "checkbox",
   top: 509.316,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 26,
   name: "Any property insurance claim submitted whether paid or not", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 506.28,
   left: 163.92,
   width: 429.24,
   height: 67.80
}
,
{
   page: 26,
   name: "Checkbox Structural architectural and engineering plans andor specifications for any existing improvements Provide copies of all such reports in possession of Seller", 
   isText: false,
   type: "checkbox",
   top: 580.588,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 26,
   name: "Structural architectural and engineering plans andor specifications for any existing improvements Provide copies of all such reports in possession of Seller", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 575.88,
   left: 163.92,
   width: 429.24,
   height: 95.16
}
,
{
   page: 26,
   name: "Checkbox Property was previously used as a methamphetamine laboratory and not remediated to state standards", 
   isText: false,
   type: "checkbox",
   top: 676.686,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 26,
   name: "Property was previously used as a methamphetamine laboratory and not remediated to state standards", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 672.84,
   left: 163.92,
   width: 429.24,
   height: 67.80
}
,
{
   page: 27,
   name: "Checkbox Government special improvements approved but not yet installed that may become a lien against the Property", 
   isText: false,
   type: "checkbox",
   top: 63.264,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "Government special improvements approved but not yet installed that may become a lien against the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 59.4,
   left: 164.444,
   width: 428.543,
   height: 55.8
}
,
{
   page: 27,
   name: "Checkbox Any litigation alleging negligent construction or defective building products", 
   isText: false,
   type: "checkbox",
   top: 120.922,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "Any litigation alleging negligent construction or defective building products", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 116.52,
   left: 164.444,
   width: 428.543,
   height: 54.36
}
,
{
   page: 27,
   name: "Checkbox Any award or payment of money in lieu of repairs for defective building products or poor construction", 
   isText: false,
   type: "checkbox",
   top: 176.979,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "Any award or payment of money in lieu of repairs for defective building products or poor construction", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 172.2,
   left: 164.444,
   width: 428.543,
   height: 68.04
}
,
{
   page: 27,
   name: "Checkbox Any release signed regarding defective products or poor construction that would limit a future owner from making a claim", 
   isText: false,
   type: "checkbox",
   top: 245.849,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "Any release signed regarding defective products or poor construction that would limit a future owner from making a claim", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 241.56,
   left: 164.444,
   width: 428.543,
   height: 68.28
}
,
{
   page: 27,
   name: "Checkbox Pending 1 litigation or 2 other dispute resolution proceeding regarding the Property", 
   isText: false,
   type: "checkbox",
   top: 313.918,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "Pending 1 litigation or 2 other dispute resolution proceeding regarding the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 311.16,
   left: 164.444,
   width: 428.543,
   height: 54.36
}
,
{
   page: 27,
   name: "Checkbox Property is subject to Deed Restrictions other recorded document restrictions or Affordable Housing Restrictions", 
   isText: false,
   type: "checkbox",
   top: 369.174,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "Property is subject to Deed Restrictions other recorded document restrictions or Affordable Housing Restrictions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 366.84,
   left: 164.444,
   width: 428.543,
   height: 68.04
}
,
{
   page: 27,
   name: "Checkbox Property is located in a historic district", 
   isText: false,
   type: "checkbox",
   top: 438.845,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "Property is located in a historic district", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 436.2,
   left: 164.444,
   width: 428.543,
   height: 54.6
}
,
{
   page: 27,
   name: "Disclosures Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 492.6,
   left: 33.36,
   width: 105.24,
   height: 39.96
}
,
{
   page: 27,
   name: "Checkbox Disclosures Extra Row", 
   isText: false,
   type: "checkbox",
   top: 495.702,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "Disclosures Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 492.763,
   left: 164.444,
   width: 428.543,
   height: 39.011
}
,
{
   page: 27,
   name: "Checkbox US Postal Service delivery available", 
   isText: false,
   type: "checkbox",
   top: 565.373,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "Checkbox USPS Property", 
   isText: false,
   type: "checkbox",
   top: 561.369,
   left: 165.768,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "Checkbox USPS Post Office", 
   isText: false,
   type: "checkbox",
   top: 562.17,
   left: 230.032,
   width: 13.680,
   height: 13.68
}
,
{
   page: 27,
   name: "Checkbox USPS Cluster Mailbox", 
   isText: false,
   type: "checkbox",
   top: 574.983,
   left: 165.768,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "USPS Cluster Mailbox", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 585.066,
   left: 181.837,
   width: 410.740,
   height: 11.814
}
,
{
   page: 27,
   name: "Checkbox USPS Other", 
   isText: false,
   type: "checkbox",
   top: 596.604,
   left: 165.768,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "US Postal Service delivery available", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 609.677,
   left: 163.92,
   width: 429.24,
   height: 50.694
}
,
{
   page: 27,
   name: "General Extra Row Title", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 663.48,
   left: 33.36,
   width: 105.24,
   height: 81.48
}
,
{
   page: 27,
   name: "Checkbox General Extra Row", 
   isText: false,
   type: "checkbox",
   top: 666.275,
   left: 144.146,
   width: 13.680,
   height: 13.680
}
,
{
   page: 27,
   name: "General Extra Row", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 663.48,
   left: 163.92,
   width: 429.24,
   height: 81.48
}
,
{
   page: 28,
   name: "Other Known Adverse Material Facts", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 69.383,
   left: 23.5637,
   width: 552.5473,
   height: 433.710
}
,
{
   page: 28,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 549.64,
   left: 43.5274,
   width: 374.4326,
   height: 16.571
}
,
{
   page: 28,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 595.6,
   left: 43.5274,
   width: 374.4326,
   height: 16.571
}
,
{
   page: 28,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 641.44,
   left: 43.5274,
   width: 374.4326,
   height: 16.571
}
,
{
   page: 28,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 687.52,
   left: 43.5274,
   width: 374.4326,
   height: 16.5712
}
] }
